<template>
  <div :id-layout="id_layout" :id-page="page_id" :data-device="device" :data-preview="preview" :data-editing="!preview"
       class="cheetah-editor">
    <div style="z-index: 1060"
         class="navbar navbar-light bg-white d-flex justify-content-between fixed-top py-0 align-items-stretch">
      <div class="container-grow text-left " id="top-menu-left">
        <div class="navbar-header-item ">
          <div class="navbar-brand-icon border-gray-right dropdown">
          <button class="btn btn-default m-0 p-0"
                  type="button"
                  id="dropdownMenuButtonNavBar"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  style="outline: unset;box-shadow:none"
                  aria-expanded="false">
            <i class="svg-icon svgi-menu-burger m-0" style="width: 26px;cursor:pointer;"></i>
<!--            <i class="svg-icon svgi-cheetah-builder svgi-lg m-0" style="width: 26px; height: 26px;cursor:pointer;"></i>-->
          </button>
          <div class="dropdown-menu py-3 px-2"
               aria-labelledby="dropdownMenuButtonNavBar"
               style="position: fixed;top: 57px; left: 12px;">
            <template>
              <router-link
                v-if="!hasExitPopupInBundleAccess"
                :to="{name: 'GeneralSettings', params: {id: id_website}}"
                target="_blank"
                class="dropdown-item">
                <i class="ct-icon-settings"/>{{ $t('ct-website-settings') }}
              </router-link>

              <router-link
                v-if="!hasExitPopupInBundleAccess"
                :to="{name: 'Analytics', params: {id: id_website}}"
                target="_blank"
                class="dropdown-item">
                <i class="ct-icon-overview"/>{{ $t('ct-website-overview') }}
              </router-link>

              <router-link
                v-if="!hasExitPopupInBundleAccess"
                :to="{name: 'GeneralSettings', params: {id: id_website}}"
                target="_blank"
                class="dropdown-item">
                <i class="svg-icon svgi-settings-seo svgi-dark"/>{{ $t('ct-seo-settings') }}
              </router-link>

              <a
                v-if="!hasExitPopupInBundleAccess && !$isBundle()"
                href="#"
                @click.prevent="openSupercheckout"
                class="dropdown-item">
                <i class="svg-icon svgi-checkout svgi-dark"></i>{{ $t('ct-supercheckout') }}
              </a>

              <a
                v-if="!hasExitPopupInBundleAccess"
                href="#"
                 @click.prevent="openBlog"
                 class="dropdown-item">
                <i class="svg-icon svgi-blog svgi-dark"></i>{{ $t('ct-blog') }}
              </a>

              <router-link
                v-if="!hasExitPopupInBundleAccess"
                :to="{name: 'SitePages', params: {id: id_website}}"
                target="_blank"
                class="dropdown-item">
                <i class="ct-icon-list-pages"></i>{{ $t('ct-website-list-pages')}}
              </router-link>

              <router-link
                :to="{name: 'Dashboard'}"
                target="_blank"
                class="dropdown-item">
                <i class="ct-icon-dashboard"/>
                {{ $t('ct-bb-home') }}
              </router-link>
            </template>
          </div>
          </div>
        </div>
<!--        <div class="navbar-header-item">-->
<!--          <div class="navbar-brand-icon border-gray-right" @click="toHomepage">-->
<!--            <i class="svg-icon svgi-cheetah-builder svgi-lg" style="width: 26px; height: 26px;cursor:pointer;"></i>-->
<!--          </div>-->
<!--        </div>-->
        <div class="d-flex justify-content-center align-items-center px-2 border-gray-right">
          <div class="navbar-header-item icon-view"
               data-ba-i="desktop-version"
               @click="buttonVersionsClick('desktop')"
               :class="{'selected' : device === 'desktop'}">
            <i class=" ct-icon-desktop" style="width: 22px;height: 22px;font-size: 22px"></i>
  <!--          <font-awesome-icon class="font-awesome-icon" :icon="['fas', 'desktop']"/>-->
          </div>
          <div v-show="tablet_version"
               class="navbar-header-item icon-view"
               data-ba-i="tablet-version"
               :class="{'selected' : device === 'tablet'}"
               @click="buttonVersionsClick('tablet')"
               :title="$t('ct-option-tablet')"
          >
            <i class=" ct-icon-tablet" style="font-size: 22px"></i>
  <!--          <font-awesome-icon class="font-awesome-icon" :icon="['fas', 'tablet-alt']"-->
  <!--                             @click="buttonVersionsClick('tablet')"/>-->
          </div>
          <div class="navbar-header-item icon-view"
               data-ba-i="mobile-version"
               @click="buttonVersionsClick('mobile')"
               :class="{'selected' : device === 'mobile'}">
            <i class=" ct-icon-mobile" style="font-size: 22px"></i>
  <!--          <font-awesome-icon class="font-awesome-icon" :icon="['fas', 'mobile-alt']"/>-->
          </div>
        </div>
        <!-- <button @click="undo(-1)" class="btn btn-default">Undo</button>
        <button @click="undo(1)" class="btn btn-default">Redo</button> -->
        <!-- <button @click="undoDeleted()" class="btn btn-default" v-show="deletedHistory.length > 0" >{{ $t('ct-undelete') }}</button> -->

        <div class="input-group page-selector-container px-2 mx-2" v-if="pages">
          <select class="" id="page-selector" v-if="pages" @change="changePage()">
            <option data-id="#option-page-new">{{ $t('ct-editor-new-page')}}</option>
            <option data-id="#option-page-duplicate">{{ $t('ct-editor-duplicate')}}</option>
            <option disabled>--------------</option>
            <option
              :value="p.id"
              :data-id="p.encrypted_id"
              v-bind:key="index"
              v-for="(p, index) in pages"
              :selected="p.id === page.id">
              {{p.name}}<span v-if="p.is_blog === 1">: {{p.url}}</span>
            </option>
          </select>
        </div>

        <router-link
          v-if="page_id && id_website"
          :to="{name: 'SitePageEdit', params: {id: id_website, page_id: $route.params.page_id}}"
          target="_blank"
          :title="$t('ct-page-edit-settings')"
          class="btn btn-primary px-3">
          <i class="ct-icon-settings m-0" style="font-size: 15px;"></i>
        </router-link>
      </div>

      <div class="container-grow" v-if="layoutItem && layout_item_type">
        <a
          href="#"
          class="btn btn-default px-0"
          @click.prevent="editName()"
        >
          <i
            v-tooltip.bottom="{
                    content: $t('ct-edit'),
                    class: 'tooltip-custom',
                  }"
            class="svg-icon svgi-edit-blue mx-0"
          ></i>
        </a>

        <p class="box-text-title-helper d-none d-lg-flex ml-3">
          {{ $t(`ct-${layout_item_type}`) }} - {{ layoutItem.name }} </p>
      </div>

      <div class="container-grow" id="top-menu-right">
        <div class="view-options d-none d-sm-inline-block">
          <ul class="list-unstyled m-0">
            <li>
              <button class="view-option" v-show="!preview" @click="undo()"
                      data-toggle="tooltip"
                      data-placement="right"
                      :title="$t('ct-undo')">
                <font-awesome-icon class="font-awesome-icon" :icon="['fas', 'undo']"/>
              </button>
            </li>
            <li>
              <button class="view-option" v-show="!preview" @click="redo()"
                      data-toggle="tooltip"
                      data-placement="right"
                      :title="$t('ct-redo')">
                <font-awesome-icon class="font-awesome-icon" :icon="['fas', 'redo']"/>
              </button>
            </li>
<!--            <li style="border-left: 1px solid #e6e8ef;"></li>-->
            <!--            <li>-->
            <!--              <button class="view-option" :class="gridline ? 'active' : ''" v-show="!preview" @click="showGridLine()"-->
            <!--                      data-toggle="tooltip"-->
            <!--                      data-placement="right"-->
            <!--                      :title="gridline ? $t('ct-hide-grid-line') : $t('ct-show-grid-line')">-->
            <!--                <font-awesome-icon class="font-awesome-icon r-90" :icon="['fas', 'grip-lines']"/>-->
            <!--              </button>-->
            <!--            </li>-->
            <li id="popup-bg-config-ref" v-show="!['popup','header','footer'].includes(layout_item_type)">
              <button class="view-option" v-show="!preview" data-toggle="tooltip" @click="showBgConfig()"
                      data-placement="right"
                      data-ba-i="bg-config"
                      :title="$t('ct-background-page')">
                <font-awesome-icon class="font-awesome-icon" :icon="['far', 'window-maximize']"/>
              </button>

              <background-page-edition ref="showBgConfigRef"></background-page-edition>
            </li>
            <li id="popup-font-group-edition">
              <button class="view-option" v-show="!preview" data-toggle="tooltip" @click="showFontGroup()"
                      data-placement="right"
                      data-ba-i="font-config"
                      :title="$t('ct-font-group-site')">
                <font-awesome-icon class="font-awesome-icon" :icon="['fas', 'font']"/>
              </button>

              <font-group-edition :font-group-edition="fontGroupEdition"
                                  ref="fontGroupEdition"
                                  :font-list="fontList"
                                  @default-font-options="defaultFontOptions = $event"/>
            </li>
            <li>
              <button class="view-option" :class="ruler ? 'active' : ''" v-show="device==='desktop' && !preview"
                      @click="showRuler()" data-toggle="tooltip"
                      data-ba-i="ruler"
                      data-placement="right"
                      :title="ruler ? $t('ct-hide-ruler') : $t('ct-ruler')">
                <font-awesome-icon class="font-awesome-icon" :icon="['fas', 'ruler-horizontal']"/>
              </button>
            </li>
            <li id="popup-panels-to-move">
              <button class="view-option" v-show="!preview" data-toggle="tooltip" @click="showPanelMoveOrder()"
                      data-placement="right"
                      data-ba-i="hidden-elements"
                      :title="$t('ct-show-panel-move-order')">
                <font-awesome-icon class="font-awesome-icon" :icon="['fas', 'arrows-alt']"/>
              </button>
              <panel-move-order ref="panelMoveOrder" @functionChangeOrderPanel="changeOrderPanel"></panel-move-order>
            </li>
            <li id="popup-hidden-side-bar">
              <button class="view-option" v-show="!preview" data-toggle="tooltip" @click="showHiddenElementsBar()"
                      data-placement="right"
                      data-ba-i="hidden-elements"
                      :title="$t('ct-show-hidden-elements')">
                <font-awesome-icon class="font-awesome-icon" :icon="['fas', 'eye']"/>
              </button>
              <hidden-elements-sidebar-component ref="hiddenSidebar"></hidden-elements-sidebar-component>
            </li>
          </ul>
        </div>
        <div class="form-inline" style="margin-right: 10px;">
          <button class="btn btn-sm btn-secondary mx-1 btn-small" type="button" @click="openVideos('addElements')" data-ba-i="tutorials">
            {{ $t('ct-tutorials') }}
          </button>

          <button class="btn btn-sm btn-dark mx-1 btn-small" type="button" @click="changeInstance"
                  data-ba-i="preview"
                  v-show="device==='desktop'">
            {{ this.preview ? this.$t('ct-return-edit') : this.$t('ct-pre-view') }}
          </button>
          <button class="btn btn-sm btn-success mx-1 btn-small" type="button" @click="save(null)" :disabled="!showRepublish"
                  data-ba-i="save-website"
                  v-show="device==='desktop' && !preview"><i class="svg-icon svgi-save mr-2"></i>{{ $t('ct-save')}}
          </button>
        </div>
      </div>
    </div>
    <keep-alive>
      <div class="modal fade default-sidebar show" id="settingsElements" role="dialog" aria-hidden="true" @mouseup="store()" @mousedown="store()">
        <div class="modal-dialog modal-settings-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header modal-header-sidebar">
              <h5 class="modal-title">{{titleModal}}</h5>
              <button type="button" class="btn btn-small" @click="closePopup">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <right-sidebar-component @openInfoHelper="openVideos" style="z-index: 1"
                                       ref="rightSidebarEdition" :hasRestrictsArea="hasRestrictsArea" :device="device"></right-sidebar-component>
            </div>
          </div>
        </div>
      </div>
    </keep-alive>

    <div style="z-index: 0" class="panel-constructor" id="panel-constructor" @mouseup="store()" @mousedown="store()">
      <div v-show="preview"  hidden="true" id="page-mask"></div>
      <div class="container-editor mx-auto">
        <div class="editor">
          <div class="editor container-fluid">
            <slot ref="faixa" name="faixa"></slot>
            <div class="editor-container" v-bind:data-device="device" v-bind:data-gridline="gridline">
              <div class="grid">
                <div class="container h-100">
                  <div class="grid-lines"></div>
                </div>
              </div>
              <!--  HEADER -->
              <header-footer-component v-if="preview && itemHeader && $route.name === 'editor'"
                                       type="header" :item="itemHeader" :device="device" :layout_id="id_layout"
                                       :page_id="page_id" :website_id="id_website" :preview="preview"
              ></header-footer-component>
              <!--  HEADER END -->

              <div id="editor-content">

                <div id="editor-ruler" :data-ruler="ruler"></div>
                <!-- <PanelElement/> -->
                <component v-for="(element,index) in elements" :is="element.name" :config="element.config"
                           :key="`${index}-${hashes[element.id]}-${keyElements}`"
                           :id="element.id" :childs="element.childs" :device="device" :preview="preview"
                           @setCallbackChangeDevice="setCallbackChangeDevice"></component>
                <div class="info-content">
                </div>
              </div>

              <!--  FOOTER -->
              <header-footer-component
                v-if="preview && itemFooter && itemFooter[device] && itemFooter[device].content && $route.name === 'editor'"
                type="footer" :item="itemFooter" :device="device" :layout_id="id_layout" :page_id="page_id"
                :website_id="id_website" :preview="preview"
              ></header-footer-component>
              <!--  FOOTER END -->

            </div>
          </div>
        </div>
      </div>
    </div>

    <button-multiple-actions ref="buttonMultipleActions" />

    <!-- modal-->
    <cc-modal-manager ref="modal-manager"></cc-modal-manager>

    <!--    BLOG-->
    <blog-settings-modal ref="blog-settings-modal"></blog-settings-modal>
    <!--    BLOG-->

    <!-- BOOKING -->
    <booking-calendar-modal ref="booking-calendar-modal"></booking-calendar-modal>
    <!-- BOOKING -->

    <!-- QUIZ -->
    <quiz-config-modal ref="quiz-config-modal"></quiz-config-modal>
    <!-- QUIZ -->

    <!-- Panda Video -->
    <panda-video-config-modal ref="panda-video-config-modal"></panda-video-config-modal>
    <!-- Panda Video -->

    <menu-config-modals ref="menu-modals"></menu-config-modals>
    <blog-news-slider-config-modals ref="blog-news-slider-modal"/>
    <video-gallery-config-modals ref="gallery-video-modals"></video-gallery-config-modals>
    <image-gallery-config-modals ref="gallery-modals"></image-gallery-config-modals>
    <slider-gallery-config-modals ref="slider-modals"></slider-gallery-config-modals>
    <checkout-modal ref="checkout-modals"></checkout-modal>

    <simple-form-config-modal ref="simple-form-modals"></simple-form-config-modal>
    <multi-step-form-config-modal ref="multi-step-form-modals"></multi-step-form-config-modal>
    <mailing-boss-form-config-modal ref="mailingboss-form-modals"></mailing-boss-form-config-modal>

    <re-captcha-component ref="recaptchaPopup"></re-captcha-component>
    <config-fields-component ref="configFields"></config-fields-component>

    <form-config-social-proof-modal ref="form-config-social-proof-modal"></form-config-social-proof-modal>

    <get-response-form-config-modal ref="getresponse-form-modals"></get-response-form-config-modal>
    <text-icon-component ref="listIcon"></text-icon-component>
    <button-user-link-config-modal :website_id="id_website" ref="link-button-user"></button-user-link-config-modal>
    <content-nav-user-settings-modal :website_id="id_website" ref="settings-container-user"></content-nav-user-settings-modal>
    <text-tag-component ref="listTag"></text-tag-component>
    <text-shadow-component ref="textShadowModal"></text-shadow-component>
    <!--    <hidden-elements-sidebar-component ref="hiddenSidebar"></hidden-elements-sidebar-component>-->
    <text-editor ref="textEditor"></text-editor>
    <resources-page ref="resourcesPage"></resources-page>

    <link-component :website_id="id_website" :layout_id="id_layout" :page_id="page_id"
                    ref="linkComponent"></link-component>

    <!-- PinElement-->>
    <pin-component  ref="PinComponent"></pin-component>

    <sticky-component ref="StickyComponent"></sticky-component>

    <sweet-modal ref="editName" width="40%" hide-close-button blocking>

     <div class="form-group" v-if="layoutItem && layout_item_type">
       <label for="">{{ $t('ct-name') }}</label>
       <input type="text" class="form-control" v-model="layoutItem.name">
       <span style="font-size: 13px">{{ $t('ct-need-save-element-to-update') }}</span>
     </div>
      <button slot="button" class="btn btn-success" @click.prevent="updateGlobalItem()">{{ $t('ct-save')}}</button>

    </sweet-modal>


    <modal-saved-and-publish ref="success" @publish="publishWebsite" :id_website="id_website" :showRepublish="showRepublish"></modal-saved-and-publish>

    <modal-upgrade-bundle ref="modal-upgrade-bundle"></modal-upgrade-bundle>

    <sweet-modal width="500px" ref="error" icon="danger">
      {{ $t('ct-error-message') }}
      <button slot="button" class="btn btn-outline-success focus" @click.prevent="publishWebsite()">{{
        $t('ct-thats-fine')}}
      </button>
    </sweet-modal>

    <sweet-modal ref="simple_success" icon="success">
      <div>
        {{ $t('ct-saved') }}
      </div>
      <button slot="button" class="btn btn-outline-success focus" @click.prevent="publishWebsite()">
        {{ $t('ct-thats-fine') }}
      </button>
    </sweet-modal>

    <delete-confirmation-modal ref="delete" @confirm="continueDelete" text=" "/>
    <delete-confirmation-modal ref="discardText" @confirm="continueDelete" />

    <sweet-modal ref="change_page" width="400px" v-on:close="resetChangePage()">
      {{ $t('ct-leave-page-msg') }}
      <div class="d-flex align-items-center justify-content-between mt-3">
        <button slot="button" id="just-exit" class="btn btn-danger m-0">{{ $t('ct-just-leave') }}</button>
        <button slot="button" id="save-and-exit" class="btn btn-success m-0 focus">{{ $t('ct-save-and-leave') }}
        </button>
      </div>
    </sweet-modal>

    <sweet-modal icon="danger" ref="publish">
      {{ $t('ct-do-want-publish-website') }}
      <button slot="button" class="btn btn-outline-danger focus" v-on:click="this.$refs.publish.close()">
        {{ $t('ct-not-now') }}
      </button>
      <button slot="button" class="btn btn-outline-success" v-on:click="console.log('oi')">{{ $t('ct-thats-fine') }}
      </button>
    </sweet-modal>

    <b-modal ref="ModalInfoVideo" size="xl" id="modal-info-video"
             @close="openVideos('close')"
             @hidden="openVideos('close')"
             data-component="modal-bootstrap-vue" no-close-on-backdrop hide-header hide-footer>
      <info-helper-component ref="infoVideo" :tabSelected="infoHelperTabSelected"></info-helper-component>
      <div class="text-right">
        <button class="btn btn-outline-info" v-if="getInfoHelperShow(this.infoHelperTabSelected)"
                v-on:click="openVideos('dont-show-again')">{{ $t('ct-dont-show-again') }}
        </button>
        <button class="btn btn-outline-danger" v-on:click="openVideos('close')">{{ $t('ct-close') }}</button>
      </div>
    </b-modal>

    <sweet-modal ref="saveElement" width="30%" class="modal-save-element" blocking>
      <save-item-component ref="saveElementComponent"></save-item-component>
    </sweet-modal>


    <sweet-modal ref="editText" width="80%" height="620px" style="overflow: hidden; z-index: 9000 !important"  hide-close-button blocking>
      <div style="height: 620px; overflow: hidden" id="edit-text-modal"></div>
      <text-editor-open style=" overflow: hidden" ref="textEditorOpen" @closePopup="$refs.editText.close() || store()"></text-editor-open>
    </sweet-modal>

    <sweet-modal
      ref="editMagicTextOpen"
      class="sweet-modal-magic-text"
      height="700px"
      style="z-index: 9000 !important" width="80%">
      <!--      <div style="height: 700px" id="edit-text-2-modal"></div>-->
      <magic-text-open ref="textEditor2Open" @closePopup="$refs.editMagicTextOpen.close()"></magic-text-open>
    </sweet-modal>

    <sweet-modal ref="uploadFont" width="30%" class="modal-upload-font" :title="$t('ct-label-upload-user-font')" blocking>
      <font-upload-component ref="fontUploadComponent"  :default-font-options="defaultFontOptions"></font-upload-component>
    </sweet-modal>

    <manage-upload-font ref="manageFontUpload"></manage-upload-font>

    <delete-confirmation-modal
      :custom="true"
      :title="$t('ct-manage-user-font-title')"
      :message="$t('ct-manage-user-font-message')"
      :confirmMessage="$t('ct-manage-user-font-confirm-message')"
      ref="deleteManageFontUpload"
      @confirm="continueDeleteFontUpload" />

    <div class="modal-loading-overlay">
      <div class="loader-spinna"></div>
    </div>

    <div id="guide-h" class="guide"></div>
    <div id="guide-v" class="guide"></div>

    <v-tour name="editorTour" ref="editorTour" :steps="this.steps" :options="this.stepsOptions"
            :callbacks="this.myStepsCallbacks" :class="'v-step-' + this.tour.currentStep">
    </v-tour>
    <div class="overlay-tour" v-if="showOverlayTour"/>

    <div class="text-warning-banner alert-info text-center" v-show="hasMessageBegin !== ''">{{hasMessageBegin}}</div>

    <div id="trash-apps" style="display: none"></div>
    <div id="trash-panels" style="display: none"></div>

    <save-website-component :id_layout="id_layout" :id_website="id_website" :type="saveTourModal.type"
                            :show="saveTourModal.show" @closeAction="closeSaveTour" :page_url="page ? page.url : ''"></save-website-component>

<!--    <page-component ref="page"></page-component>-->

  </div>
</template>
<script>

  import LinkComponent from './link/Link';
  import PinComponent from './Pin';
  import StickyComponent from './Sticky';
  import InfoHelperComponent from './InfoHelper';
  import Player from '@vimeo/player';

  import PanelElement from '../apps/Panel/Panel.vue';
  import RightSidebarComponent from '@/components/editor/base/sidebar/RightSidebar.vue';

  import SimpleFormConfigModal from '@/components/editor/apps/Forms/SimpleForm/ConfigModals';
  import MultiStepFormConfigModal from '@/components/editor/apps/Forms/MultiStepForm/ConfigModals';
  import FormConfigSocialProofModal from '@/components/editor/apps/Forms/SocialProof/ConfigSocialProof';
  import CheckoutModal from '@/components/editor/apps/Checkout/ConfigModal';
  import MailingBossFormConfigModal from '@/components/editor/apps/Forms/MailingBossForm/ConfigModals';
  import QuizConfigModal from '@/components/editor/apps/Quiz/ConfigModals';
  import PandaVideoConfigModal from '@/components/editor/apps/PandaVideo/ConfigModals';

  import GetResponseFormConfigModal from '@/components/editor/apps/Forms/GetResponseForm/ConfigModals';
  import ButtonUserLinkConfigModal from '@/components/editor/apps/Members/ButtonUser/ConfigLink';
  import ContentNavUserSettingsModal from '@/components/editor/apps/Members/ContentNavUser/Config';

  import ResourcesPage from '@/components/editor/base/sidebar/ResourcesPage.vue';
  import HiddenElementsSidebarComponent from '@/components/editor/base/sidebar/HiddenElementsSidebar.vue';
  import TextEditor from '@/components/editor/base/TextEditor.vue';
  import TextEditorOpen from '@/components/editor/base/TextEditorOpen.vue';
  import MagicTextOpen from '@/components/editor/base/MagicTextOpen.vue';
  import {get as getHeader, update as updateHeader} from '../../../js/services/editor/headers';
  import {get as getFooter, update as updateFooter} from '../../../js/services/editor/footers';
  import {get as getPopup, update as updatePopup} from '../../../js/services/editor/popups';
  import {duplicate as duplicatePage, getBit} from '../../../js/services/editor/page';
  import {
    getLayoutConfig,
    setLayoutConfig,
    getPageConfig,
    setPageConfig
  } from '../../../js/services/editor/configManager';
  import {getItems, storeItems} from '../../../js/services/editor/item';
  import {getDefaultItem, updateDefaultItem} from '../../../js/services/editor/defaultItem';
  import {updateVersion} from '../../../js/services/editor/publish';
  import {SweetModal} from 'sweet-modal-vue';
  import SaveItemComponent from '../resources/SaveItem';
  import TextIconComponent from '../resources/TextIcon';
  import FontUploadComponent from '../resources/UploadFont';
  import ManageUploadFont from '../resources/ManageUploadFont';
  import {mapGetters} from 'vuex';
  import axios from 'axios';
  import SaveWebsiteComponent from '../../dashboard/components/SaveWebsiteComponent.vue';
  import TextShadowComponent from '../resources/TextShadow';
  import TextTagComponent from '../resources/TextTag';
  import HeaderFooterComponent from './editor/HeaderFooter';
  import {getWebsiteLink} from '../../../js/services/editor/link';
  import MenuConfigModals from '../apps/Menu/ConfigModals';
  import SliderGalleryConfigModals from '../apps/SliderGallery/ConfigModals';
  import ImageGalleryConfigModals from '../apps/ImageGallery/ConfigModals';
  import ReCaptchaComponent from '../resources/ReCaptcha';
  import ConfigFieldsComponent from '../resources/ConfigFields';
  import PageComponent from '../../dashboard/pages/Page';
  import VideoGalleryConfigModals from '../apps/VideoGallery/Gallery/ConfigModals';
  import ButtonMultipleActions from "../resources/ButtonMultipleActions";

  // Booking
  import BookingCalendarModal from '../apps/Booking/Calendar/ConfigModals'


  //blog
  import BlogSettingsModal from '../apps/Blog/Settings/Structure';
  import BlogNewsSliderConfigModals from '../apps/Blog/NewsSlider/ConfigModals'
  import FontGroupEdition from "./sidebar/FontGroupEdition";
  import BackgroundPageEdition from "./sidebar/BackgroundPageEdition";
  import PanelMoveOrder from "./sidebar/PanelMoveOrder";
  import {apiUrl, auth as supercheckoutAuth} from "../../../js/services/integrations-internas/supercheckout";
  import ModalSavedAndPublish from "../../commons/ModalSavedAndPublish.vue";
  import ModalUpgradeBundle from "../../dashboard/components/ModalUpgradeBundle.vue";

  require('./editor/editor.scss');
  require('./../apps/Timer/FlipClock/_flipclock.scss');

  var componentColorClicked = null;

  export default {
    name: 'EditorComponent',
    components: {
      BackgroundPageEdition,
      FontGroupEdition,
      BookingCalendarModal,
      VideoGalleryConfigModals,
      PageComponent,
      ReCaptchaComponent,
      ConfigFieldsComponent,
      ImageGalleryConfigModals,
      SliderGalleryConfigModals,
      MenuConfigModals,
      TextTagComponent,
      TextShadowComponent,
      FontUploadComponent,
      TextIconComponent,
      SaveItemComponent,
      LinkComponent,
      InfoHelperComponent,
      PanelElement,
      RightSidebarComponent,
      ResourcesPage,
      HiddenElementsSidebarComponent,
      TextEditor,
      TextEditorOpen,
      MagicTextOpen,
      SweetModal,
      PinComponent,
      StickyComponent,
      SaveWebsiteComponent,
      HeaderFooterComponent,
      SimpleFormConfigModal,
      MultiStepFormConfigModal,
      MailingBossFormConfigModal,
      GetResponseFormConfigModal,
      BlogNewsSliderConfigModals,
      BlogSettingsModal,
      ButtonUserLinkConfigModal,
      ContentNavUserSettingsModal,
      ButtonMultipleActions,
      CheckoutModal,
      FormConfigSocialProofModal,
      QuizConfigModal,
      PandaVideoConfigModal,
      ManageUploadFont,
      PanelMoveOrder,
      ModalSavedAndPublish,
      ModalUpgradeBundle
    },
    props: {
      msg: String
    },
    data() {
      return {
        showRepublish: true,
        history: [],
        deletedHistory: [],
        historyIdx: 0,
        tablet_version: 0,
        titleModal: '',
        keyElements: 'abc',
        hasMessageBegin: '',
        hasRestrictsArea: false,
        saveTourModal: {
          type: 'save',
          show: 0
        },
        stepsOptions: {
          useKeyboardNavigation: false,
          labels: {}
        },
        offsetScroll: 0,
        showOverlayTour: false,
        myStepsCallbacks: {
          onStop: this.stopJoyRide,
          onStart: this.startJoyRide,
          onNextStep: this.nextActionJoyRide
        },
        tour: {
          currentStep: 0
        },
        steps: [],
        elementToDelete: null,
        selectedElement: null,
        draggable: null,
        saveData: [],
        elements: [],
        sorts: [],
        device: 'desktop',
        copiedElement: null,
        gridline: false,
        oldgridline: true,
        preview: false,
        ruler: false,
        timeToClose: 0,
        oldruler: false,
        id_website: null,
        id_layout: null,
        page_id: null,
        page: null,
        website: {},
        pages: null,
        nextId: new Date().valueOf(),
        anchors: [],
        fontGroupEdition: null,
        fontList: null,
        defaultFontOptions: [],
        fontOptions: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p'],
        bgPropsPage: {
          'backgroundColor': '#FFFFFF',
          'backgroundImage': null, /* url("photographer.jpg"); The image used */
          'backgroundPosition': 'center', /* Center the image */
          'backgroundOrigin': 'border-box', /* padding-box|border-box|content-box Do not repeat the image */
          'backgroundRepeat': 'no-repeat', /* repeat | repeat-x | repeat-y | no-repeat | space | round   Do not repeat the image */
          'backgroundSize': 'cover', /* 'auto | 50% | 100% 100% | cover | contain  'Resize the background image to cover the entire container */
          'backgroundAttachment': 'scroll'
        },
        defaultItem: [],
        default_item_type: null,
        layoutItem: {},
        layout_item_type: null,
        getLayoutItem: null,
        updateLayoutItem: null,
        fontGroup: {
          h1: {
            'family': 'Muli Black, sans-serif',
            'size': '80px',
            'sizeMobile': '40px',
            'line-height': '1.1em',
            'text-align': 'center',
            'color': 'black'
          },
          h2: {
            'family': 'Muli Black, sans-serif',
            'size': '45px',
            'sizeMobile': '25px',
            'line-height': '1.1em',
            'text-align': 'center',
            'color': 'black'
          },
          h3: {
            'family': 'Muli, sans-serif',
            'size': '45px',
            'sizeMobile': '25px',
            'line-height': '1.1em',
            'text-align': 'center',
            'color': 'black'
          },
          h4: {
            'family': 'Muli, sans-serif',
            'size': '35px',
            'sizeMobile': '20px',
            'line-height': '1.1em',
            'text-align': 'center',
            'color': 'black'
          },
          h5: {
            'family': 'Muli, sans-serif',
            'size': '25px',
            'sizeMobile': '18px',
            'line-height': '1em',
            'text-align': 'center',
            'color': 'black'
          },
          h6: {
            'family': 'Muli, sans-serif',
            'size': '20px',
            'sizeMobile': '15px',
            'line-height': '1em',
            'text-align': 'center',
            'color': 'black'
          },
          p: {
            'family': 'Muli, sans-serif',
            'size': '17px',
            'sizeMobile': '15px',
            'text-align': 'center',
            'line-height': '1em',
            'color': 'black'
          }
        },
        infoHelperTabSelected: '',
        callbackChangeDevice: {},
        rulerZeroPoint: {
          x: 0,
          y: (76 + 18)
        },
        tokenCheckout: '',
        itemHeaders: [],
        itemFooters: [],
        itemHeader: {mobile: {}, desktop: {}},
        itemFooter: {mobile: {}, desktop: {}},
        versioning: {old: [], new: [], cur: null, curt: null},
        hashes: {},
        anchorsThrottle: {timer: null},
        planSlug: ''
      };
    },
    computed: {
      bundleRedirectURL() {
        return `#${localStorage.getItem('bundle_redirect_url') || '/'}`;
      },
      hasExitPopupInBundleAccess() {
        const value = this.$route.query.is_exit_popup_in_bundle_access;
        return value == 'true' || value == '1';
      }
    },
    watch: {
      'device': function (value) {
        // todo fazer um for com todas as function
        if (typeof this.callbackChangeDevice === 'function') {
          this.callbackChangeDevice(value);
        }
      },
      elements: function(elements) {
        this.removeProperty(elements, 'parent_id');

        this.hashes = Object.assign({}, ...elements.map(element => {
          const str = JSON.stringify(element);

          let hash = 0;
          for (let i = 0; i < str.length; i++) {
            const char = str.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash |= 0;
          }

          return {[element.id]: hash};
        }));

        //console.debug('trigger elements', this.hashes);
      }
    },
    methods: {
      ...mapGetters({getUser: 'user', getOfficeToken: 'getOfficeToken'}),
      openSupercheckout() {
        supercheckoutAuth(this.website.id, this.website.language).then(async({data}) => {
            if (data.token) {
              let token = data.token;
              localStorage.setItem('token_supercheckout', token);
              this.tokenCheckout = token;

              return window.open(`${apiUrl()}?token=${this.tokenCheckout}`);
            }
          });
      },
      getSuperCheckoutAuth() {
        if (this.website && typeof this.website.encrypted_id !== 'undefined') {
          supercheckoutAuth(this.website.id, this.website.language).then(async({data}) => {
            if (data.token) {
              let token = data.token;
              localStorage.setItem('token_supercheckout', token);
              this.tokenCheckout = token;
            }
          });
        }
      },
      getBlogUrl() {
        const baseURLs = {
          'local':'http://blog.localhost',
          'io'   :'https://blog.kub.app.builderall.io',
          'info' :'https://blog.kub.app.builderall.info',
          'com'  :'https://blog.builderall.com'
        }

        let url = ''

        if(window.location.host.includes('localhost:')) {
          url = baseURLs.local
        } else {
          url = baseURLs[
            window.location.host.includes('.com') ? 'com' : (
              window.location.host.includes('.info') ? 'info' : 'io'
            )
          ]
        }

        return `${url}/logincheetah-login?token=J0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9&user_token=${this.getOfficeToken()}`
      },
      openBlog() {
        let url = this.getBlogUrl();
        url = url + '&website_id=' + this.id_website;

        window.open(url, '_blank');
      },
      editName() {
          this.$refs.editName.open();
      },

      openSettingsPage() {
        this.$router.push({name: 'SitePageEdit', params: {page_id: this.page.encrypted_id}});
      },

      continueDeleteFontUpload() {
        this.$refs.manageFontUpload.continueDelete();
      },

      updateGlobalItem() {
        if(this.layoutItem.name === "") {
          this.layoutItem.name = "my " + this.layout_item_type;
        }
        this.$snotify.success(this.$t("ct-success-true"));
        this.$refs.editName.close();

        // if(this.layout_item_type === "popup") {
        //   updatePopup(this.layoutItem)
        //   .then( (res => {
        //     this.$snotify.success(this.$t('ct-updated'));
        //     this.$refs.editName.close();
        //   }) )
        // }
        //
        // if(this.layout_item_type === "header") {
        //   updateHeader(this.layoutItem)
        //     .then( (res => {
        //       this.$snotify.success(this.$t('ct-updated'));
        //       this.$refs.editName.close();
        //     }) )
        // }
        //
        // if(this.layout_item_type === "footer") {
        //   updateFooter(this.layoutItem)
        //     .then( (res => {
        //       this.$snotify.success(this.$t('ct-updated'));
        //       this.$refs.editName.close();
        //     }) )
        // }
      },

      setFontGroup() {
        this.$refs.fontGroupEdition.$refs.fontColor.forEach(ref => {
          let obj = {
            defaultValue: this.fontGroupEdition[ref.$attrs.id].color,
            callback: (value) => {
              this.$root.$emit('changeFontGroup', ref.$attrs.id, 'color', value);
            }
          };
          ref.setValues(obj);
        });
      },
      getFirstPanel(device) {
        var deviceFinish = device || this.device;
        deviceFinish = this.device.substr(0, 1).toUpperCase() + this.device.substr(1).toLowerCase();

        let firstPanel = this.elements.find(element => element.config[`show${deviceFinish}`]) || false;

        if (this.page && this.page.config && this.page.config.headerSettings && this.page.config.headerSettings.value && this.$isJson(this.page.config.headerSettings.value)) {
          let header = JSON.parse(this.page.config.headerSettings.value);
          if (header && header[deviceFinish.toLowerCase()].header_id !== 0) {
            return false;
          }
        }

        if (firstPanel) {
          return firstPanel
        }

        return false;
      },

      closeSaveTour() {
        this.saveTourModal.show = 0;
      },

      setCallbackChangeDevice(values) {
        // todo add em formato push
        this.callbackChangeDevice = values;
      },

      applyBackground() {
        let bg = this.bgPropsPage.backgroundColor;

        if (this.bgPropsPage.backgroundImage) {
          bg += ' url("' + this.bgPropsPage.backgroundImage + '")';
          bg += ' ' + this.bgPropsPage.backgroundPosition;
          bg += ' / ' + this.bgPropsPage.backgroundSize;
          bg += ' ' + this.bgPropsPage.backgroundRepeat;
          bg += ' ' + this.bgPropsPage.backgroundOrigin;
          if (typeof this.bgPropsPage.backgroundAttachment !== 'undefined') {
            bg += ' ' + this.bgPropsPage.backgroundAttachment
          }
        }
        document.body.style.setProperty('--bg-page', bg);
      },

      applyFontGroup: function () {
        Object.keys(this.fontGroup).forEach(font => {
          document.body.style.setProperty('--text-family-' + font, this.fontGroup[font].family);
          document.body.style.setProperty('--text-size-' + font, this.fontGroup[font].size);
          document.body.style.setProperty('--text-size-mobile-' + font, this.fontGroup[font].sizeMobile);
          document.body.style.setProperty('--text-color-' + font, this.fontGroup[font].color);
          document.body.style.setProperty('--text-line-height-' + font, this.fontGroup[font]['line-height']);
          // document.body.style.setProperty('--text-align-' + font, this.fontGroup[font]['text-align']);
        });
      },

      buttonVersionsClick(device) {
        this.$root.$emit('destroyCk');

        if (this.preview) {
          this.showVersion(device)
        } else {
          let vm = this;
          vm.$loading.show();
          setTimeout( () => {
            vm.changeVersion(device)
          }, 600 )
        }
      },

      showVersion(version) {
        this.device = version;
      },
      changeVersion(version) {
        let vm = this;
        this.hidePopup();

        this.$loading.show();

        vm.$refs.hiddenSidebar.hidePanel();


        /**
       * update element to change device
       */
        let elements = vm.updateChilds();
        vm.$eventHub.addElements(elements);
        vm.$eventPointer.addElements(elements);

        if (version !== 'desktop') {
          this.bubbleSortMobile(() => {
            vm.ruler = false;
            setTimeout(function () {
              vm.$loading.hide();
              vm.keyElements = vm.genRandomKey();
            }, 2000);

            vm.device = version;
            return vm.device;
          });
        } else {
          vm.ruler = false;
          vm.$loading.hide();
          vm.elements = vm.$eventHub.getElements();
          vm.keyElements = vm.genRandomKey();
          vm.device = version;

          this.$nextTick(() => {
            vm.sort();
          });
          return vm.device;
        }
      },

      changeFontGroup() {
        if (!this.preview) {
          this.$root.$emit('showFontConfigPage');
        }
      },

      startJoyRide() {
        this.showOverlayTour = true
      },

      stopJoyRide() {
        this.showOverlayTour = false;
        localStorage.setItem('joyride-executed', 'executed');
      },

      nextActionJoyRide(currentStep) {
        if (currentStep == 0) {
          $('#tab-add-panel').trigger('click');
        }
        if (currentStep == 1) {
          $('#tab-add-panel-action').trigger('click');
        }
      },

      changeInstanceReal() {
        this.preview = !this.preview;

        if (this.preview) {
          this.oldgridline = this.gridline;
          this.oldruler = this.ruler;
          this.gridline = false;
          this.ruler = false;
          this.$refs['rightSidebarEdition'].hiderSidebarEdition();
          this.$refs.hiddenSidebar.hidePanel();
          let elements = document.getElementsByClassName('widget-focused');
          [].forEach.call(elements, function (el) {
            el.classList.remove('widget-focused');
            el.classList.remove('default-options-top');
          });
        } else {


          this.$refs['rightSidebarEdition'].hSidebarEdition();

          this.gridline = this.oldgridline;
          this.ruler = this.oldruler;
          $('.animated').removeClass('animated');
        }

        $('div.selected').removeClass('selected');

        let vm = this;
        let elements = vm.updateChilds();

        this.$nextTick(() => {
          vm.elements = elements;
          vm.keyElements = vm.genRandomKey();
          $('div.selected').removeClass('selected');

          this.$nextTick(() => {
            vm.sort();
            vm.$loading.hide();
          });
        });
        return this.preview;
      },

      changeInstance() {
        this.$loading.show();
        let vm = this;

        setTimeout(() => {
          return vm.changeInstanceReal();
        }, 100);
      },

      exit(callback) {
        var vm = this;
        vm.$refs.change_page.open();

        $('#just-exit').click(function () {
          window.removeEventListener('beforeunload', vm.beforeClose);
          callback();
        });

        $('#save-and-exit').click(function () {
          window.removeEventListener('beforeunload', vm.beforeClose);
          vm.save(callback);
        });
      },

      toNewPage() {
        const route = this.$router.resolve({
          name: 'editor',
          params: { page_id : data.page.encrypted_id }
        });
        window.open(route.href, '_blank');
      },

      toDuplicatePage() {
        this.$loading.show();

        duplicatePage({
          encrypted_id: this.page_id
        })
          .then(({data}) => {
            this.$snotify.success(this.$t('ct-duplicate-success'));

            const route = this.$router.resolve({
              name: 'editor',
              params: { page_id : data.page.encrypted_id }
            });
            window.open(route.href, '_blank');

          })
          .catch(error => {
            if (error.response) {
              // Request made and server responded
              if (error.response.status === 429) { // to many
                this.$snotify.error(this.$t('ct-too-many-attempts'));
              }
            }
          })
          .finally(() => this.$loading.hide());
      },

      changePage() {
        var vm = this;
        var id = $('#page-selector').find(':selected').data('id');

        if (['#option-page-new', '#option-page-duplicate'].includes(id)) {
          if (id === '#option-page-new') {
            this.newPage()
          } else if (id === '#option-page-duplicate') {
            this.toDuplicatePage()
          }

          $('#page-selector').val(this.page.id)
        } else {
          this.exit(function () {
              var id = $('#page-selector').find(':selected').data('id');
              vm.$router.replace({name: 'editor', params: {page_id: id}});
              location.reload();
            }
          );
        }
      },

      resetChangePage() {
        $('#page-selector').val(this.page.id);
      },

      newPage() {
        let route = this.$router.resolve({
          name: 'SitePageCreate',
          params: {id: this.id_website, layout_id: this.id_layout}
        });
        window.open(route.href, '_blank');
        // this.$refs['page'].new(this.id_layout);
      },

      showGridLine() {
        this.gridline = !this.gridline;
        return this.gridline;
      },

      showRuler() {
        if (!this.preview) {
          this.ruler = !this.ruler;

          if (this.ruler) {
            let vm = this;
            setTimeout(function () {
              let width = 0;
              if (!document.getElementById('editor-content').classList.contains('popup-editor')) {
                /* if (window.innerWidth > 1485) {
                      width = ((window.innerWidth - 1500) / 2) * -1 - 5;
                    } else {
                      width = ((window.innerWidth - 1080) / 2) * -1 - 5;
                    } */
                var wi = window.innerWidth;
                var we = document.getElementById('editor-content').clientWidth;
                var cw = 0;
                if (wi > 1200) {
                  cw = 1140;
                  width = (we - cw) / 2 * -1 + 15;
                } else if (wi > 992) {
                  cw = 960;
                  width = (we - cw) / 2 * -1 + 15;
                } else if (wi > 800) {
                  cw = 0;
                  width = (we - cw) / 2 * -1 + 15;
                } else {
                  cw = 0;
                  width = cw + -18;
                }
              }

              let $editorRuler = $('#editor-ruler');
              $editorRuler.ruler({
                showLabel: true,
                startX: width
              });

              $editorRuler.find('.ruler').unbind();
              vm.initLocalStorageRuler();

              $editorRuler.find('.ruler.top').get(0).style.width = (parseInt($editorRuler.find('.ruler.top').get(0).style.width) + 20) + 'px';
              $editorRuler.find('.ruler.top').on('click', function (e) {
                let ePageX = e.pageX;
                if (document.getElementById('editor-content').classList.contains('popup-editor')) {
                  ePageX = ePageX - document.getElementById('editor-content').getBoundingClientRect().left;
                }
                vm.addRulerLine('x', ePageX, null, true);
              });
              $editorRuler.find('.ruler.left').on('click', function (e) {
                let valuePlus = ($(document).scrollTop() === 0 ? 0 : 50);
                vm.addRulerLine('y', e.pageY, valuePlus, true);
              });

              vm.rulerZeroPoint.x = $editorRuler.find(".ruler.top .major:contains('0')").filter(function () {
                return $(this).text() === '0';
              }).position().left + 18;
            }, 200);
          }

          return this.ruler;
        }
      },

      initLocalStorageRuler() {
        let localRulerStored = localStorage.getItem('ruler_marks');
        let vm = this;
        if (localRulerStored !== null) {
          JSON.parse(localRulerStored).forEach(function (value, key) {
            vm.addRulerLine(value[0], value[1], value[2]);
          });
        }
      },

      addRulerLine(axis, ePageAxis, valuePlus = 0, saveInLocalStorage = false) {
        let vmVue = this;
        let classRuler = axis == 'x' ? 'line-vert' : 'line-hor';
        let cssRuler = axis == 'x'
          ? {'left': ePageAxis}
          : {'top': ePageAxis - $(document).scrollTop() + valuePlus - $('#editor-content').offset().top};

        function removeRulerMarkLocal(paxis, pePageAxis) {
          let localRulerDelete = localStorage.getItem('ruler_marks');
          if (localRulerDelete !== null) {
            let newLocalStorage = JSON.parse(localRulerDelete).filter(function (value, key) {
              return !(value[0] == paxis && value[1] == pePageAxis);
            });
            localStorage.setItem('ruler_marks', JSON.stringify(newLocalStorage));
          }
        }

        function removeDOMLine(target) {
          if ($(target).hasClass('buble-remove-mark')) {
            $(target).parent().remove();
          } else {
            $(target).remove();
          }
        }

        $('<div><span class="buble-remove-mark">x</span><span class="tooltip-position-ruler"></span>')
          .addClass('line-ruler ' + classRuler)
          .draggable({
            axis: axis,
            drag: function (ev) {
              let calc = (axis == 'x' ? ev.pageX - vmVue.rulerZeroPoint.x : ev.pageY - vmVue.rulerZeroPoint.y);
              $(this).children('.tooltip-position-ruler').text(calc + 'px');
            },
            stop: function (ev) {
              // update position ondrag in localStorage
              removeRulerMarkLocal(axis, ePageAxis);
              removeDOMLine(ev.target);
              vmVue.addRulerLine(axis, axis == 'x' ? ev.pageX : ev.pageY, null, true);
              $(this).children('.tooltip-position-ruler').text('');
            }
          })
          .css(cssRuler)
          .on('click', function (e) {
            // remove on click from localStorage and DOM
            removeRulerMarkLocal(axis, ePageAxis);
            removeDOMLine(e.target);
          })
          .appendTo($('#editor-ruler').find('.ef-ruler').get(0));

        if (saveInLocalStorage) {
          let localRuler = localStorage.getItem('ruler_marks');
          localRuler = localRuler === null ? [] : JSON.parse(localRuler);
          localRuler.push([axis, ePageAxis, valuePlus]);
          localStorage.setItem('ruler_marks', JSON.stringify(localRuler));
        }
      },

      async undo() {
        if (this.versioning.old.length === 0) return;

        const current = this.versioning.cur;
        const previous = this.versioning.old.pop();

        if (current === previous) {
          await this.undo();
          return;
        }

        this.versioning.new.push(current);
        this.versioning.cur = previous;

        await this.restore(JSON.parse(previous));

        console.debug("UNDO", this.versioning.old.length, this.versioning.new.length);
      },
      async redo() {
        if (this.versioning.new.length === 0) return;

        const current = this.versioning.cur;
        const next = this.versioning.new.pop();

        if (current === next) {
          await this.redo();
          return;
        }

        this.versioning.old.push(current);
        this.versioning.cur = next;

        await this.restore(JSON.parse(next));

        console.debug("REDO", this.versioning.new.length);
      },
      async  store() {
        await this.$nextTick();

        const current = await this.dump();
        if (current.elements.length === 0) return;

        const encoded = JSON.stringify(current);

        if (encoded === this.versioning.cur) return;

        const TIME_LIMIT = 200;
        const HISTORY_LIMIT = 20;

        const now = Date.now();

        if (this.versioning.cur && now - this.versioning.curt > TIME_LIMIT) {
          this.versioning.old.push(this.versioning.cur);
          if (this.versioning.old.length > HISTORY_LIMIT) this.versioning.old.shift();
          this.versioning.curt = now;
        }
        this.versioning.cur = encoded;
        this.versioning.new = [];

        //console.debug("STORE", Date.now());
      },
      async restore({device, elements}) {
        this.device = device;
        await this.$nextTick();

        const panelConstructor = document.getElementById("panel-constructor");
        const previousScrollTop = panelConstructor.scrollTop;

        this.elements = elements;
        await this.$nextTick(() => this.$eventHub.addElements(this.elements));
        await this.$nextTick(() => this.sort({ignoreStore: true}));

        panelConstructor.scrollTop = previousScrollTop;
      },
      async dump() {
        await this.$nextTick();
        const elements = this.isMobile() ? this.elements : this.updateChilds(true);
        const current = JSON.parse(JSON.stringify(elements));
        this.removeProperty(current, "parent_id");
        return {device: this.device, elements: current};
      },
      removeProperty(obj, prop) {
        if (!obj || typeof obj !== 'object') return;

        if (Array.isArray(obj)) {
          for (let i = 0; i < obj.length; i++)
            this.removeProperty(obj[i], prop);
          return;
        }

        delete obj[prop];

        for (const key in obj) {
          if (obj.hasOwnProperty(key))
            this.removeProperty(obj[key], prop);
        }
      },
      showHiddenElementsBar() {
        this.$refs.showBgConfigRef.hidePanel();
        this.$refs.fontGroupEdition.hidePanel();
        this.$refs.panelMoveOrder.hidePanel();

        this.$root.$emit('showHiddenElementsBar', this.device);
      },
      showPanelMoveOrder() {
        this.$refs.showBgConfigRef.hidePanel();
        this.$refs.fontGroupEdition.hidePanel();

        this.$refs.panelMoveOrder.showPanel();
      },
      showFontGroup() {
        this.$refs.showBgConfigRef.hidePanel();
        this.$refs.hiddenSidebar.hidePanel();
        this.$refs.panelMoveOrder.hidePanel();

        this.$root.$emit('showFontGroupBar');
      },
      showBgConfig() {
        this.$refs.fontGroupEdition.hidePanel();
        this.$refs.hiddenSidebar.hidePanel();
        this.$refs.panelMoveOrder.hidePanel();


        this.$root.$emit('showBgConfigPage', this.$refs.resourcesPage);
      },
      add() {
      },
      changeOrderElementsWithArray(panelID, configArray, elementsPanel) {
        let vm = this;


        let elements = [];
        let panelSelected = {};
        let childsSelected = [];
        let idxPanel = 0;

        this.elements.forEach((panel, idx) => {
          if (panel.id == panelID) {
                panelSelected = panel;
                idxPanel = idx;
          }
        });

        // vm.elements[idxPanel].childs = [];
        // vm.elements[idxPanel].childs = elementsPanel;

        configArray.forEach((position, index) => {
             vm.elements[idxPanel].childs.forEach((child) => {
               if(position.id == child.id){
                    child.config.order_mobile = position.order;
                    // console.log(child.name);
                    // console.log(child.config.order_mobile);

                    elements[index] = child;
                }
            })

        })


        vm.elements[idxPanel].childs = [];
        vm.elements[idxPanel].childs = elements;

            vm.$nextTick(() => {
              let elms = vm.elements;
              vm.$eventHub.addElements(elms);
              vm.keyElements = vm.genRandomKey();

              this.$nextTick(function () {
                vm.sort();
              });

          })


        return  { childs : elements }
      },
      changeOrderElements(panelId, id, siblingID, idx) {

        let elements = {};

        this.elements.forEach((elem, idxElem) => {
          if (elem.id == panelId) {
            elements = this.elements[idxElem];
            elem.childs.forEach((child, idxChild) => {
              if (child.id == id) {
                elements.childs[idxChild].config.order_mobile = child.config.order_mobile + (idx);
              }
              if (child.id == siblingID) {
                elements.childs[idxChild].config.order_mobile = child.config.order_mobile - (idx);
              }
            });
          }
        });

        return elements;
      },

      bubbleSortMobile(callback) {
        function bubbleRecursive(childs) {
          let newOrder = 0;
          let newOrderHidden = 999;
          childs.forEach((child, idxChild) => {
            if (child.config.showMobile == true) {
              childs[idxChild].config.order_mobile = newOrder++;
            } else {
              childs[idxChild].config.order_mobile = newOrderHidden--;
            }

            if (typeof child.childs !== 'undefined' && child.childs.length > 0) {
              bubbleRecursive(child.childs);
            }
          });

          return childs;
        }

        let vm = this;
        let elements = this.$eventHub.getElements();

        this.$nextTick(function () {
          if (!(Object.keys(elements).length === 0 && elements.constructor === Object)) {
            elements.forEach((elem, idxElem) => {
              elements[idxElem].childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
            });

            elements.forEach((elem, idxElem) => {
              elements[idxElem].childs = bubbleRecursive(elements[idxElem].childs);
            });
          }
          this.$nextTick(function () {
            vm.elements = elements;
            vm.keyElements = vm.genRandomKey();
            this.$nextTick(function () {
              vm.sort();
              callback();
            });
          });
        });
      },

      genRandomKey() {
        return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
      },

      createElement(parentID, componentName, configData, el, callback) {
        let obj = {
          id: this.getNextId(),
          name: componentName,
          config: configData
        };

        if (typeof el !== 'undefined' && el !== null && typeof el.childs !== 'undefined' && el.childs !== null && el.childs.length > 0) {
          obj.childs = JSON.parse(JSON.stringify(el.childs));
        }

        if (typeof parentId === 'string') {
          parentId = parentId.replace('place-menu-', '');
        }

        this.$eventHub.addElement(parentID, obj);

        this.$root.$emit('setChildsObj', parentID);
        this.$nextTick(() => {
          this.checkJoyRide();
          this.sort();

          if (typeof callback === 'function') {
            callback(obj.id);
          }
        });
      },

      checkJoyRide() {
        let vm = this;

        setTimeout(() => {
          if (document.querySelectorAll('.sitebuilder-element-panel').length === 0) {
            vm.hasMessageBegin = vm.$t('ct-joyride-add-one-panel');
          } else {
            if (document.querySelectorAll('.sitebuilder-element-container').length === 0) {
              vm.hasMessageBegin = vm.$t('ct-joyride-add-one-element');
            } else {
              vm.hasMessageBegin = '';
            }
          }
        }, 1000);
      },

      createElementDrop(parentID, componentName, configData, el) {
        if (componentName === 'TextComponent' && configData.content.toLowerCase().indexOf('ct-title-') >= 0) {
          let tag = 'ct-title-' + configData.tag;
          if(configData.tag == 'p')
            tag = 'ct-title-helper-p';
          configData.content = configData.content.replace(tag, this.$t(tag));
        }

        let obj = {
          id: this.getNextId(),
          name: componentName,
          config: configData
        };

        if (typeof el !== 'undefined' && el !== null && typeof el.childs !== 'undefined' && el.childs !== null && el.childs.length > 0) {
          obj.childs = JSON.parse(JSON.stringify(el.childs));
        }
        if (typeof el.get(0) !== 'undefined' && el.get(0) !== null && typeof el.get(0).dataset.childs !== 'undefined' && el.get(0).dataset.childs !== null && el.get(0).dataset.childs.length > 0) {
          obj.childs = JSON.parse(JSON.stringify(el.get(0).dataset.childs));
        }

        let onPanel = false;



        this.$children.forEach( (element) => {
          if(
            typeof element.$el.getAttribute === 'function' &&
            element.$el.getAttribute('element') === 'PanelComponent' &&
            obj.name !== 'AccordionGroupComponent' &&
            obj.name !== 'SliderGroupComponent' &&
            obj.name !== 'BoxComponent' &&
            obj.name !== 'BoxHoverComponent' &&
            obj.name !== 'GroupMenuComponent' &&
            obj.name !== 'VideoGalleryGroupComponent'
            ) {
            if( parseInt(element.$el.__vue__.id) === parseInt(parentID)) { element.$el.__vue__.elements.push(obj); onPanel = true;}
          }
        } )


        if(!onPanel){
            this.$eventHub.addElement(parentID, obj);
            this.$root.$emit('setChildsObj', parentID);
        }


        this.$nextTick(() => {
          this.checkJoyRide();
          this.sort();
        });
      },

      sort(props) {
        if (!(props && props.ignoreStore)) this.store();

        let vm = this;

        var MIN_DISTANCE = 3; // minimum distance to "snap" to a guide
        var guides = []; // no guides available ...
        var innerOffsetX, innerOffsetY; // we'll use those during drag ...
        var selectedObjs;

        function computeGuidesForElement(elem, pos, w, h) {
          if (elem != null) {
            var $t = $(elem);
            pos = $t.offset();
            w = elem.scrollWidth - 1;
            h = elem.scrollHeight - 1;
          }

          return [
            {type: 'h', left: pos.left, top: pos.top},
            {type: 'h', left: pos.left, top: pos.top + h},
            {type: 'v', left: pos.left, top: pos.top},
            {type: 'v', left: pos.left + w, top: pos.top},
            // you can add _any_ other guides here as well (e.g. a guide 10 pixels to the left of an element)
            {type: 'h', left: pos.left, top: pos.top + h / 2},
            {type: 'v', left: pos.left + w / 2, top: pos.top}
          ];
        }

        function moveSelected(ol, ot) {
          selectedObjs.each(function () {
            var $this = $(this);
            var p = $this.position();
            var l = p.left;
            var t = p.top;

            $this.css('left', l + ol);
            $this.css('top', t + ot);
          });
        }

        //console.debug('ENABLE DRAG', document.querySelectorAll('.sitebuilder-element-container:not(.drag-enabled), .panel-body:not(.drop-enabled), .sitebuilder-element-receiver:not(.drop-enabled)').length);

        $('.sitebuilder-element-container:not(.drag-enabled)')
          .draggable({
            snap: '.line-ruler',
            scroll: false,
            cancel: '.rotate__container, .sync-drag__container',
            start: function (event, ui) {
              if (vm.device === 'mobile' || vm.device === 'tablet' || vm.preview === true) {
                return false;
              }

              if (
                $(this).attr('element') === 'AccordionComponent' ||
                $(this).attr('element') === 'FloatingButtonComponent' ||
                $(this).attr('element') === 'VideoGalleryComponent' ||
                $(this).attr('element') === 'SliderPageComponent' ||
                $(this).attr('element') === 'PlaceMenuComponent'
              ) {
                return false
              }

              $(this).data('dragging', true);

              guides = $.map($('.sitebuilder-element-container').not(this), computeGuidesForElement);
              innerOffsetX = event.originalEvent.offsetX;
              innerOffsetY = event.originalEvent.offsetY;

              if (ui.helper.hasClass('selected')) selectedObjs = $('div.selected');
              else {
                selectedObjs = $(ui.helper);
                $('div.selected').removeClass('selected');
              }
            },
            drag: function (event, ui) {

              if($(this).attr('element') === 'BoxComponent' && $(this).hasClass('pinActivated')) ui.position = ui.originalPosition;
              else{
              // smart guides
              var guideV, guideH, distV = MIN_DISTANCE + 1, distH = MIN_DISTANCE + 1, offsetV, offsetH;
              var chosenGuides = {top: {dist: MIN_DISTANCE + 1}, left: {dist: MIN_DISTANCE + 1}};
              var pos = {
                top: event.originalEvent.pageY - innerOffsetY,
                left: event.originalEvent.pageX - innerOffsetX
              };
              var w = this.scrollWidth - 1;
              var h = this.scrollHeight - 1;
              var elemGuides = computeGuidesForElement(null, pos, w, h);

              $.each(guides, function (i, guide) {
                $.each(elemGuides, function (i, elemGuide) {
                  if (guide.type == elemGuide.type) {
                    var prop = guide.type == 'h' ? 'top' : 'left';
                    var d = Math.abs(elemGuide[prop] - guide[prop]);
                    if (d < chosenGuides[prop].dist) {
                      chosenGuides[prop].dist = d;
                      chosenGuides[prop].offset = elemGuide[prop] - pos[prop];
                      chosenGuides[prop].guide = guide;
                    }
                  }
                });
              });

              if (chosenGuides.top.dist <= MIN_DISTANCE) {
                $('#guide-h').css('top', chosenGuides.top.guide.top).show();
              } else {
                $('#guide-h').hide();
              }

              if (chosenGuides.left.dist <= MIN_DISTANCE) {
                $('#guide-v').css('left', chosenGuides.left.guide.left).show();
              } else {
                $('#guide-v').hide();
              }

              var currentLoc = $(this).position();
              var prevLoc = $(this).data('prevLoc');
              if (!prevLoc) {
                prevLoc = ui.originalPosition;
              }

              var offsetLeft = currentLoc.left - prevLoc.left;
              var offsetTop = currentLoc.top - prevLoc.top;

              moveSelected(offsetLeft, offsetTop);
              selectedObjs.each(function () {
                $(this).removeData('prevLoc');
              });
              $(this).data('prevLoc', currentLoc);
            }
            },
            stop: function (event) {

              const movedElement = document.getElementById(event.target.id)
              const parentPanel = document.getElementById(event.target.id).parentElement.parentElement;
              let configItem = JSON.parse(document.getElementById(movedElement.id).getAttribute('config-properties'));

              /**
               * check parents and check drop area
               */
              // let parentId = parseInt(configItem.parent_id);
              // let newParentId = parseInt(parentPanel.id);

              // if(parentId === newParentId) {

              //   let topElement = movedElement.getBoundingClientRect().top;
              //   let heightPanel = parseInt(parentPanel.style.height);
              //   let topPanel = parentPanel.getBoundingClientRect().top;
              //   let bottomPanel = (topPanel + heightPanel);


              //   if(topElement > bottomPanel) {
              //      document.getElementById(movedElement.id).style.top = `${bottomPanel - 300}px`;
              //   }

              //   // if(topElement > topPanel) {
              //   //    document.getElementById(movedElement.id).style.top = `${topPanel - 300}px`;
              //   // }

              // }


              /**
               * get actual position
               */
              // vm.history[vm.historyIdx] = { element: movedElement.id, type: 'move', top: configItem.top, left: configItem.left };
              // vm.historyIdx++;
              // console.log(vm.history);

              /**g
               * update configs
               */


              configItem.top = movedElement.getBoundingClientRect().top - parentPanel.getBoundingClientRect().top;
              configItem.left = movedElement.getBoundingClientRect().left - parentPanel.querySelector('.ui-droppable').getBoundingClientRect().left;
              configItem.parent_id = parseInt(parentPanel.id);
              movedElement.setAttribute('config-properties', JSON.stringify(configItem));

              // vm.history[vm.historyIdx] = { element: movedElement.id, type: 'move', top: configItem.top, left: configItem.left };
              // vm.historyIdx++;



              $('#guide-v, #guide-h').hide();
              $('div.selected').removeClass('selected');

              setTimeout(function () {
                $(event.target).data('dragging', false);
              }, 1);
            }
          })
          .addClass('drag-enabled')
          .click(function (event) {
            // if ($('.selected').length > 1) {
            if (event.shiftKey && vm.device === 'desktop') {
              $(this).addClass('selected');
            } else {
              $('div.selected').removeClass('selected');
            }
          });

        $('.panel-body:not(.drop-enabled), .sitebuilder-element-receiver:not(.drop-enabled)')
          .droppable({
            hoverClass: 'ui-state-active',
            accept: '.addElement,.sitebuilder-element-container',
            tolerance: 'pointer',
            greedy: true,
            drop: function (event, ui) {
              // debugger;

              // se onde vai dropar é receiver e o elemento a ser dropado é receiver, bloqueia a açao
              if ($(event.target).parent().parent().hasClass('is-receiver') && $(ui.draggable[0]).hasClass('is-receiver')) {
                console.log('dropou onde nao devia');
                // return false;
              }
              if ($(event.target).parent().parent().hasClass('big-is-receiver') && $(ui.draggable[0]).hasClass('big-is-receiver')) {
                vm.$snotify.warning(vm.$t('ct-vc-eh-besta'));
                return false;
              }

              // let parentId = event.target.parentNode.id;
              // if (parentId === '') {
              //   parentId = event.target.parentNode.parentNode.id;
              // }

              if ($(ui.helper).hasClass('addElement')) {
                let elem = $(ui.helper).clone();
                let configElement = JSON.parse(elem.get(0).dataset.config);
                configElement['top'] = (ui.offset.top - $(event.target).offset().top) + 'px';
                configElement['left'] = (ui.offset.left - $(event.target).offset().left) + 'px';

                let parentId = event.target.parentNode.id;
                if (parentId === '') {
                  parentId = event.target.parentNode.parentNode.id;
                }

                parentId = parentId.replace('collapse', '');

                vm.updateChilds();
                vm.$nextTick(function () {
                  vm.createElementDrop(parentId, elem.get(0).dataset.ref, configElement, elem);
                });
              } else {
                let idElement = $(ui.draggable[0])[0].id;

                // se o pai for diferente
                if (event.target !== $(ui.draggable[0]).parent()[0]) {
                  $(ui.draggable[0]).css({
                    top: (ui.offset.top - $(event.target).offset().top) + 'px',
                    left: (ui.offset.left - $(event.target).offset().left) + 'px'
                  });

                  // troca no html
                  $(ui.draggable[0]).detach();
                  $(ui.draggable[0]).appendTo(event.target);

                  vm.$nextTick(function () {
                    vm.updateChilds();

                    vm.$nextTick(function () {
                      vm.sort();
                    });
                  });
                } else {
                  vm.$nextTick(function () {
                    vm.sort();

                    if($(event.target).hasClass('is-box-hover-component')) {
                      vm.updateChilds();
                    }
                  });
                }

                // code to specify the new left/top to elements, including the hide ones
                setTimeout(() => {
                  let objInformation = JSON.parse(document.getElementById(idElement).getAttribute('config-properties'));

                  objInformation.left = document.getElementById(idElement).style.left;
                  objInformation.top = document.getElementById(idElement).style.top;

                  if (document.getElementById(idElement).getAttribute('element') === 'LottieFileComponent') {
                    vm.$root.$emit('setLottieFileObj', idElement);
                  }
                  document.getElementById(idElement).setAttribute('config-properties', JSON.stringify(objInformation));
                }, 1000);
              }
              return false;
            }
          })
          .addClass('drop-enabled');
      },

      // usado no updateChilds e no save
      runUpdatesOnElements(saveData, allElements) {
        if (typeof saveData === 'undefined') {
          saveData = [];
        }

        allElements.forEach(elObj => {
          let savePanel = {};
          let htmlElem = document.getElementById(elObj.id);

          savePanel.name = htmlElem.getAttribute('element');
          savePanel.id = htmlElem.getAttribute('id');
          savePanel.config = JSON.parse(htmlElem.getAttribute('config-properties'));

          // Orphan tree: containers mirror childs into config; only savePanel.childs is canonical.
          if (savePanel.config && typeof savePanel.config.childs !== 'undefined') {
            delete savePanel.config.childs;
          }

          if (savePanel.name == 'PanelComponent') {
            savePanel.name = 'PanelElement';
          }

          if (
            (
              savePanel.name == 'BoxComponent' ||
              savePanel.name == 'BoxHoverComponent' ||
              savePanel.name == 'GroupMenuComponent' ||
              savePanel.name == 'PlaceMenuComponent' ||
              savePanel.name == 'AccordionComponent' ||
              savePanel.name == 'AccordionGroupComponent' ||
              savePanel.name == 'VideoGalleryGroupComponent' ||
              savePanel.name == 'VideoGalleryComponent' ||
              savePanel.name == 'SliderGroupComponent' ||
              savePanel.name == 'SliderPageComponent' ||
              savePanel.name == 'PanelElement'
            ) &&
            typeof savePanel.childs === 'undefined'
          ) {
            savePanel.childs = [];
          }
          if (savePanel.name != 'PanelElement') {
            let topPanel = htmlElem.parentNode.getBoundingClientRect().top;
            let leftPanel = htmlElem.parentNode.getBoundingClientRect().left;

            let checkDesktopView = savePanel.config.showDesktop && this.device === 'desktop';

            if ($(htmlElem).is(':visible')) {
              savePanel.config.top = (checkDesktopView ? (htmlElem.getBoundingClientRect().top - topPanel) + 'px' : savePanel.config.top);
              savePanel.config.left = (checkDesktopView ? (htmlElem.getBoundingClientRect().left - leftPanel) + 'px' : savePanel.config.left);
            }

            savePanel.config.order_mobile = JSON.parse(htmlElem.getAttribute('config-properties')).order_mobile;
          }

          let childsHtml =
            Array.from(htmlElem.querySelectorAll('.sitebuilder-element-container'))
              .filter(node => node.parentNode === htmlElem ||
                node.parentNode.parentNode === htmlElem ||
                node.parentNode.parentNode.parentNode === htmlElem);

          if (savePanel.name == 'VideoGalleryGroupComponent') {
            childsHtml = Array.from(htmlElem.querySelectorAll('.video-gallery-app-video'));
          }

          if (typeof childsHtml !== 'undefined' && childsHtml.length > 0) {
            savePanel.childs = this.runUpdatesOnElements(savePanel.childs, childsHtml);
          }

          this.$eventHub.setValueElement(elObj.id, savePanel);
          saveData.push(savePanel);
          // console.log(savePanel);
        });

        return saveData;
      },

      // update position of elements when stop drag
      updateChilds(ignoreSort) {
        try {
          let vm = this;

          let editorDiv = document.getElementById('editor-content');
          let panelsDiv = editorDiv.querySelectorAll('.panel');

          this.saveData = [];
          this.runUpdatesOnElements(this.saveData, panelsDiv);

          if (!ignoreSort) {
            this.$nextTick(function() {
              vm.sort();
            });
          }
        } catch (e) {
          console.log(e);
        }

        return this.saveData;
      },

      continueDelete() {
        let app = this.elementToDelete;

        let componentName = document.getElementById(app.id).getAttribute('element');

        if (componentName == 'PanelComponent') {
          this.$root.$emit('removePanel', app.id);
        } else {
          this.selectedElement = null;

          this.$refs.delete.close();
          let vm = this;
          // document.getElementById(app.id).parentNode.removeChild(document.getElementById(app.id));

          let boxParent = $(`#${app.id}`).parent().closest('[element="BoxComponent"]')
          let parentID = '';

          if(boxParent.length) {
              parentID = boxParent[0].id
          } else {

          let panelParent = $(`#${app.id}`).parent().closest('[element="PanelComponent"]')
              parentID = panelParent[0].id

          }

          document.getElementById('trash-apps').appendChild(document.getElementById(app.id));

          let insert = true;

          this.elements = this.updateChilds();
          this.$nextTick(() => {
            vm.$eventHub.addElements(this.elements);
            // vm.$eventPointer.addElements(this.elements);
            vm.checkJoyRide();

            if (componentName == 'AccordionComponent') {
              vm.$root.$emit('removeAccordion');
              insert = false;
            }
            if (componentName == 'VideoGalleryComponent') {
              vm.$root.$emit('removeGalleryVideo', app.id);
              insert = false;
            }
            if (componentName == 'SliderPageComponent') {
              vm.$root.$emit('removeSliderPage');
              insert = false;
            }
            if (componentName == 'PlaceMenuComponent') {
              vm.$root.$emit('removeMenu');
              insert = false;
            }

            if(insert && parentID !== ""){

              vm.deletedHistory.push({
                type: 'element',
                parentID: parentID,
                id: app.id
              })

            }
          });
        }

        //close rightbar
        if(typeof this.$refs.rightSidebarEdition !== 'undefined') {
          this.$refs.rightSidebarEdition.hideSidebar();
        }

        this.elementToDelete = null;

      },

      getNextId() {
        return this.nextId++;
      },

      save(callback) {
        this.$loading.show();

        try {
          let editorDiv = document.getElementById('editor-content');
          let panelsDiv = editorDiv.querySelectorAll('.panel');

          this.saveData = [];
          this.runUpdatesOnElements(this.saveData, panelsDiv);

          // save default items ou pagina normal
          if (this.$route.name === 'editor-default-item') {
            // se o id do painel for panel-default-item, o tipo do elemento é

            if (this.default_item_type === 'app') {
              if (this.saveData[0].childs.length > 1) {
                alert('somente 1 elemento, somente 1 painel');
                return;
              }

              let defaultItem = this.defaultItem;

              defaultItem.content = JSON.stringify(this.saveData[0].childs[0]);
              defaultItem.name = this.saveData[0].childs[0].name;
              updateDefaultItem(defaultItem, this.$route.params.id_default_item)
                .then(res => {
                  if (typeof callback === 'function' && callback != null) {
                    callback(this.saveData);
                  } else {
                    this.$loading.hide();
                    this.$refs.simple_success.open();
                  }
                });
            }

            if (this.default_item_type === 'block') {
              let defaultItem = this.defaultItem;

              defaultItem.content = JSON.stringify(this.saveData);
              defaultItem.name = 'BlockDefaultElement';
              updateDefaultItem(defaultItem, this.$route.params.id_default_item)
                .then(res => {
                  if (typeof callback === 'function' && callback != null) {
                    callback(this.saveData);
                  } else {
                    this.$loading.hide();
                    this.$refs.simple_success.open();
                  }
                });
            }
          } else {
            // save itens from layout, like popup/header/footer
            if (this.$route.name === 'editor-layout-item') {
              this.layoutItem.content = JSON.stringify(this.saveData);

              this.$loading.show();
              this.updateLayoutItem(this.layoutItem)
                .then(async res => {
                  await setLayoutConfig({
                    layout_id: this.layoutItem.layout_encrypted_id,
                    key: 'presetColors',
                    value: JSON.stringify(localStorage.getItem('presetColors') || [])
                  }).then(() => {
                    setLayoutConfig({
                      layout_id: this.layoutItem.layout_encrypted_id,
                      key: 'fontGroup',
                      value: JSON.stringify(this.fontGroup)
                    }).then(() => {
                    });
                  });

                  if (typeof callback === 'function' && callback != null) {
                    callback(this.saveData);
                  } else {
                    this.$loading.hide();
                    this.$refs.simple_success.open();
                  }
                }).finally(() => this.$loading.hide());
            } else {
              // console.log('save normal');
              storeItems(JSON.stringify(this.saveData), this.page_id)
                .then(() => {
                  setLayoutConfig({
                    layout_id: this.id_layout,
                    key: 'presetColors',
                    value: JSON.stringify(localStorage.getItem('presetColors') || [])
                  }).then(() => {
                    setLayoutConfig({
                      layout_id: this.id_layout,
                      key: 'fontGroup',
                      value: JSON.stringify(this.fontGroup)
                    }).then(() => {
                      setPageConfig({
                        page_id: this.page_id,
                        key: 'bgPropsPage',
                        value: JSON.stringify(this.bgPropsPage)
                      }).then(() => {
                        if (typeof callback === 'function' && callback != null) {
                          callback(this.saveData);
                        } else {
                          this.$loading.hide();
                          this.$refs.success.open();
                        }
                      });
                    });
                  });
                })
                .finally(() => this.$loading.hide());
            }
          }
        } catch (e) {
          console.log(e);
          this.$loading.hide();
          this.$refs.errorMessage.open();
        }
      },

      async getUserPlan() {
        this.planSlug = localStorage.getItem('plan_slug');

        if (this.planSlug) return this.planSlug;

        const officeUrl = process.env.OFFICE_URL !== 'undefined'
          ? process.env.OFFICE_URL
          : 'https://office.builderall.com';

        const userEmail = this.$store.getters.user.email;
        if (!userEmail) return null;

        try {
          const response = await fetch(`${officeUrl}/br/office/user/info/${userEmail}`);
          const data = await response.json();

          if (data.status === 'success' && data.data.active_plan) {
            this.planSlug = data.data.active_plan.slug;
            localStorage.setItem('plan_slug', this.planSlug);
            return this.planSlug;
          }
        } catch (error) {
          console.warn('Erro ao carregar plano do usuário:', error);
        }

        return null;
      },

      async publishWebsite() {
        this.$refs.success.close();
        this.$refs.simple_success.close();

        // Se for bundle-plan, mostrar modal de upgrade
        if (this.$isBundle() && !this.hasExitPopupInBundleAccess) {
          this.$refs['modal-upgrade-bundle'].open();
          return;
        }

        // console.log('veio pro publish do editor')
        this.showRepublish = false;

        const info = this.$snotify.info(
          `${this.$t("ct-republishing")}...`,
          '',
          {
            timeout: 9999999999,
            showProgressBar: false
          }
        );

        if (window.location.hostname == 'localhost') {
          axios.get('http://publication.localhost/cheetah/local-publish-aux').then((res) => {
            console.log(res.data);
          });
        }
        this.$loading.disabledPaceJs(true);

        updateVersion(this.id_website)
          .then(res => {
            console.log(res.data);
            this.$loading.disabledPaceJs();
            this.$refs.success.close();

             this.$loading.show();

            setTimeout(() => {
              this.$loading.hide();
              this.$refs.success.close();
              this.saveTourModal.show = 1;
            }, 2000);
          })
          .catch(error => {
            this.$refs.success.close();

             if (error.response.status === 401) {
              const message = (error.response && error.response.data && error.response.data.message) ? error.response.data.message : 'ct-plan-limited'
              this.$snotify.error(this.$t(message));
              } else {
              this.$snotify.error('Something happened when trying to publish your site, check the settings');
              }

          })
          .finally(() => {
            this.showRepublish = true

            setTimeout(() => {
              this.$snotify.remove(info.id)
            }, 6000);
          });


      },

      clone: function clone(obj) {
        if (obj == null || typeof obj !== 'object') return obj;
        var copy = obj.constructor();
        for (var attr in obj) {
          if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
        }
        return copy;
      },

      getInfoHelperShow: function (tabSelected) {
        return (!localStorage.getItem('modalInfoHelper') & tabSelected === 'savePanelsTab');
      },

      openVideos: function (tab) {
        if (tab && tab === 'close') {
          if( typeof this.$refs.infoVideo  === 'undefined') {
            return;
          }

          var div = this.$refs.infoVideo.$el.getElementsByClassName('tab-pane');

          Object.keys(div).forEach(index => {
            var iframe = div[index].querySelector('iframe');

            if (iframe) {
              if (iframe.src.indexOf('player.vimeo.com') > -1) {
                try {
                  var player = new Player(iframe);
                  player.pause();
                } catch (e) {
                  console.warn(e);
                }
              } else {
                $(div).find('iframe').each(function () {
                  var src = $(this).attr('src');
                  $(this).attr('src', src);
                });
              }
            }
          });
          this.$refs.ModalInfoVideo.hide();
          return;
        } else if (tab && tab === 'dont-show-again') {
          localStorage.setItem('modalInfoHelper', true);
          this.openVideos('close');
          return;
        }

        if (tab === 'savePanelsTab' && localStorage.getItem('modalInfoHelper')) {
          return;
        }

        this.infoHelperTabSelected = tab;
        this.$refs.ModalInfoVideo.show();
      },

      keyboardMap: function (event) {
        let vm = this;
        let keyMapping = {
          Delete: function () {
            if (vm.selectedElement && !vm.isModalOpen()) {
              vm.$root.$emit('deleteElement', vm.selectedElement);
              event.preventDefault();
            }
          },
          ArrowUp: function () {
            if (vm.selectedElement && !vm.isModalOpen()) {
              if (vm.isMobile() && vm.selectedElement.$refs.optionsBar) {
                vm.selectedElement.$refs.optionsBar.callReorder(-1);
              } else {
                vm.selectedElement.$el.style.top = (parseInt(vm.selectedElement.$el.style.top) - 1) + 'px';
              }
              event.preventDefault();
            }
          },
          ArrowDown: function () {
            if (vm.selectedElement && !vm.isModalOpen()) {
              if (vm.isMobile() && vm.selectedElement.$refs.optionsBar) {
                vm.selectedElement.$refs.optionsBar.callReorder(1);
              } else {
                vm.selectedElement.$el.style.top = (parseInt(vm.selectedElement.$el.style.top) + 1) + 'px';
              }
              event.preventDefault();
            }
          },
          ArrowLeft: function () {
            if (vm.selectedElement && !vm.isMobile() && !vm.isModalOpen()) {
              vm.selectedElement.$el.style.left = (parseInt(vm.selectedElement.$el.style.left) - 1) + 'px';
              event.preventDefault();
            }
          },
          ArrowRight: function () {
            if (vm.selectedElement && !vm.isMobile() && !vm.isModalOpen()) {
              vm.selectedElement.$el.style.left = (parseInt(vm.selectedElement.$el.style.left) + 1) + 'px';
              event.preventDefault();
            }
          },
          KeyD: function () {
            if (!vm.isMobile() && !vm.isModalOpen() && vm.selectedElement.$refs.optionsBar && (event.ctrlKey || event.metaKey) && vm.selectedElement) {
              vm.selectedElement.$refs.optionsBar.duplicateElement();
              event.preventDefault();
            }
          },
          KeyC: function () {
            if (!vm.isMobile() && !vm.isModalOpen() && (event.ctrlKey || event.metaKey) && vm.selectedElement && vm.parentIsPanel(vm.selectedElement)) {
              vm.copiedElement = JSON.parse(JSON.stringify(vm.$eventHub.getElement(vm.selectedElement.$el.id)));
            }
          },
          KeyZ: function () {
            if (vm.isModalOpen() || !(event.ctrlKey || event.metaKey)) return;
            if (event.shiftKey) {
              vm.redo();
            } else {
              vm.undo();
            }
          },
          KeyY: function () {
            if (vm.isModalOpen() || !(event.ctrlKey || event.metaKey)) return;
              vm.redo();
          },
          KeyV: function () {
            if (!vm.isMobile() && (event.ctrlKey || event.metaKey) && vm.copiedElement && !vm.isModalOpen()) {
              let pageCenter = $('#panel-constructor').scrollTop() + ($(window).height() / 2);
              let sumHeight = 0;
              let centerPanel = vm.elements.find((panel) => {
                sumHeight += $('#' + panel.id).height();
                if (pageCenter <= sumHeight) {
                  return panel;
                }
              });
              centerPanel = centerPanel || vm.elements[0];
              let configData = vm.copiedElement.config;
              configData.parent_id = centerPanel.id;
              configData.id = vm.getNextId();
              configData.top = pageCenter - (sumHeight - $('#' + centerPanel.id).height()) + 'px';
              configData.left = (570 - ($('#' + vm.copiedElement.id + ' :first-child').width() / 2 || 0)) + 'px';

              vm.createElement(centerPanel.id, vm.copiedElement.name, configData, vm.copiedElement);
            }
          },
          Enter: function () {
            if (vm.isModalOpen()) {
              if(vm.elementToDelete!== null){
                vm.$refs.delete.confirm();
              }
              $('.sweet-modal.is-visible button.focus').click();
              event.preventDefault();
            }
          },
          NumpadEnter: function () {
            this.Enter();
          },
          Escape: function () {
            if (vm.isModalOpen()) {
              return;
            }

            vm.selectedElement = null
            vm.checkJoyRide();

            $('.nav-link, .tab-pane').removeClass('active')
            $('.sitebuilder-element-container.widget-focused').removeClass('widget-focused')
          }
        };

        if (typeof keyMapping[event.code] !== 'undefined' && !vm.preview && !$('input, textarea').is(':focus')) {
          keyMapping[event.code]();
        }
      },

      closePopup() {
        $('.modal-header-sidebar').hide();
        this.$refs['rightSidebarEdition'].showSidebarEdition();
      },
      hidePopup() {
        $('body').removeClass('modal-open');
        $('.off-sidebar .modal-header-sidebar').hide();
        $('.off-sidebar .panel-components-right').hide();
      },

      isMobile: function () {
        return this.device === 'mobile' || this.device === 'tablet';
      },

      isModalOpen: function () {
        return !!($('.sweet-modal.is-visible').length || $('[element="TextComponent"][data-editing="true"]').length);
      },

      parentIsPanel: function (element) {
        return element.$parent.$el.getAttribute('element') === 'PanelComponent';
      },

      beforeClose: function (event) {
        // Chrome requires returnValue to be set
        let confirmationMessage = window.vm.$t('ct-before-close');

        (event || window.event).returnValue = confirmationMessage; // Gecko + IE

        return confirmationMessage;
      },

      addDefaultBlock(data) {

        data.forEach(newPanel => {
          this.$eventHub.addPanel(newPanel);
        });

        this.$snotify.success(this.$t('ct-panel-created'));

        this.elements = this.$eventHub.getElements();
        this.$eventHub.addElements(this.elements);

        //console.log(this.elements);


        this.$nextTick(() => {
          this.sort();
        });

        this.checkJoyRide();

      },

      duplicatePanel(idPanel) {

        let editorDiv = document.getElementById('editor-content');
        let panelsDiv = editorDiv.querySelectorAll('.panel');

        this.saveData = [];
        this.runUpdatesOnElements(this.saveData, panelsDiv);

        // this.$eventPointer.logEditor(this.elements);

        this.elements = this.$eventHub.duplicatePanel(idPanel);
        // this.keyElements = vm.genRandomKey();
        this.$nextTick(() => {
          // this.$eventPointer.logEditor(this.elements);
          this.sort();
        });
      },

      getActualElements() {
           return JSON.parse(JSON.stringify(this.updateChilds()));
      },

      undoDeleted() {
        if(this.deletedHistory.length > 0) {
          let state = this.deletedHistory[this.deletedHistory.length - 1];

          if(state.type == 'panel') {
            this.restorePanelDeleted(state.id)
          }

          if(state.type === 'element') {
            //console.log(state)
              document.getElementById(state.parentID).querySelector('.ui-droppable').appendChild(document.getElementById(state.id));
          }

            this.deletedHistory.splice(-1,1)

        }
      },

      restorePanelDeleted(id) {
        let vm = this;

        let elements = vm.getActualElements();
        let newElements = [];


        let referenceToRestore = document.getElementById(id)
        let panelToRestore = JSON.parse(referenceToRestore.getAttribute('panel'))
        let indexToRestore = parseInt(referenceToRestore.getAttribute('index'))
        let restored = false

        for (var i in elements) {
          if (indexToRestore == i) {
            newElements.push(panelToRestore);
            restored = true;
          }

          newElements.push(JSON.parse(JSON.stringify(elements[i])));

        }

        if(!restored) {
          newElements.push(panelToRestore);
        }

        this.elements = newElements;

        referenceToRestore.remove();

        this.$nextTick(() => {
          vm.$eventHub.addElements(vm.elements);
          vm.keyElements = vm.genRandomKey();
          vm.checkJoyRide();
          document.getElementById('panel-constructor').scrollTop = vm.offsetScroll;

          this.$nextTick(() => {
            // vm.$eventPointer.logEditor(vm.elements);
            vm.sort();
          });
        });


      },

      removePanel(id)  {
        let vm = this;
        // document.getElementById(id).parentNode.parentNode.removeChild(document.getElementById(id).parentNode);
        // let elements = JSON.parse(JSON.stringify(this.updateChilds()));
        // this.$eventPointer.logEditor(elements);

        const previousScrollTop = document.getElementById('panel-constructor').scrollTop;

        let elements = vm.getActualElements();
        let newElements = [];
        let deletedElements = [];

        for (var i in elements) {
          if (elements[i].id != id) {
            newElements.push(JSON.parse(JSON.stringify(elements[i])));
          } else{
            deletedElements.push( { index: i, panel: JSON.parse(JSON.stringify(elements[i])) } );
          }
        }

        if(deletedElements.length > 0) {
          deletedElements.forEach( (panel) => {
            let div = $('<div>').attr({
              index: panel.index,
              id:`panel-deleted-${panel.panel.id}`,
              panel: JSON.stringify(panel.panel),
            })

            div.appendTo($('#trash-panels'))

            vm.deletedHistory.push({
              type: 'panel',
              id: `panel-deleted-${panel.panel.id}`
            })
          } )
        }


        this.elements = newElements;

        this.$nextTick(() => {
          vm.$eventHub.addElements(vm.elements);
          vm.keyElements = vm.genRandomKey();
          vm.checkJoyRide();

          this.$nextTick(() => {
            document.getElementById('panel-constructor').scrollTop = previousScrollTop;
            // vm.$eventPointer.logEditor(vm.elements);
            vm.sort();
          });
        });
      },

      addBaseElement(elem, data) {

        let parentId = document.getElementsByClassName('panel-primary')[0].id;

        this.createElement(parentId, elem, data, null);

        this.$nextTick(function () {
          this.checkJoyRide();
        });
      },
      addElementWithClick(componentName, config) {
        try {
          const {$el} = this.selectedElement;

          const isPanel = $el;
          const fatherIsPanel = $el.parentNode.parentNode;

          let panelID;

          if (isPanel.getAttribute('element') === 'PanelComponent') {
            panelID = isPanel.children[0].getAttribute('id');
            config.top = `${isPanel.offsetHeight / 2.5}px`;
            config.left = '50%';
          } else if (fatherIsPanel.getAttribute('element') === 'PanelComponent') {
            panelID = fatherIsPanel.getAttribute('id');
            config.top = `${fatherIsPanel.offsetHeight / 2.5}px`;
            config.left = '50%';
          } else {
            return this.$snotify.warning(this.$t('ct-select-panel'));
          }

          this.createElement(panelID, componentName, config, {});
          this.$nextTick(function () {
            this.checkJoyRide();
          });
        } catch (err) {
          this.$snotify.warning(this.$t('ct-select-panel'));
        }
      },

      fakeSave() {
        //fake save
        function _newElement(element) {
            return {
                id: element.getAttribute('id'),
                name: element.getAttribute('element'),
                config: JSON.parse(element.getAttribute('config-properties')),
                childs: []
            };
        }

        function _checkisReceiverAndMakeObject(element) {
            let childNode = document.getElementById(element.id);

            if(childNode.className.indexOf('is-receiver') !== -1) {

                document.getElementById(element.id).querySelectorAll('[element]').forEach( (newElement) => {
                    element.childs.push(_newElement(newElement));
                } )

                element.childs.forEach( (child) => {
                    _checkisReceiverAndMakeObject(child)
                } )

            }
        }


        let elementsToSave = [];
        let panels =  document.querySelectorAll('#editor-content > [element="PanelComponent"]  > [element="PanelComponent"]');

        panels.forEach( (panel) => {

            let newElement = _newElement(panel);
            newElement.name = "PanelElement";

            document.getElementById(newElement.id).querySelectorAll('[element]').forEach( (element) => {
                newElement.childs.push(_newElement(element));
            } )
            newElement.childs.forEach( (child) => {
                _checkisReceiverAndMakeObject(child)
            } )

            elementsToSave.push(newElement);

        } )


        return elementsToSave;

      },

       changeOrderPanel(data, scroolTargetPanelId) {
          let vm = this;
         window.vm.$loading.show();

         let panelsOnline = this.$eventHub.getElements();
         let newObject = [];


          data.forEach( (order) => {
            panelsOnline.forEach( (panel) => {
              if(parseInt(panel.id) === parseInt(order)) {
                newObject.push(panel)
              }
            } )
          } )



         this.$eventHub.addElements(newObject);

          this.$nextTick(() => {
            vm.elements = newObject;

            vm.$eventHub.addElements(vm.elements);
            vm.updateChilds();
            vm.keyElements = vm.genRandomKey();


            $('div.selected').removeClass('selected');

            this.$nextTick(() => {
              // vm.updateChilds();
              vm.sort();
              window.vm.$loading.hide();

              // scrool to panel
              if (scroolTargetPanelId) {
                const el = document.getElementById(scroolTargetPanelId)
                if (el) {
                  el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: "nearest"
                  });
                }
              }
            });
          });

         return;

          let idxPanelToChange = 'no';
          let nodeToChange = false;
          let newPosition = position;


          document.querySelectorAll('#editor-content > [element="PanelComponent"] > [element="PanelComponent"]').forEach( (panel, index) => {
            if (parseInt(panel.getAttribute('id')) === parseInt(idPanel)) {
              nodeToChange = panel.parentElement;
              idxPanelToChange = index;
              if(!position) {
                if(direction === 'down') {
                  newPosition = index + 1;
                } else {
                  newPosition = index - 1;
                }
              }
            }


          } )

          console.log('new position')
          console.log(newPosition)

          if (idxPanelToChange !== 'no') {

            let panelsOnDisplay =  document.querySelectorAll('#editor-content > [element="PanelComponent"]');

            if(newPosition < 0 || newPosition >= panelsOnDisplay.length) {
              console.log('nao  move');
              return;
            }

            //remover panel do dom
            let auxPanel = nodeToChange;
            nodeToChange.parentElement.removeChild(nodeToChange);
            let panelsArray = [];


            panelsOnDisplay =  document.querySelectorAll('#editor-content > [element="PanelComponent"]');

            panelsOnDisplay.forEach( (panel, index) => {
              if(parseInt(index) === parseInt(newPosition)) { panelsArray.push(auxPanel) }
              panelsArray.push(panel)
            })

            if(panelsOnDisplay.length === newPosition) {
              panelsArray.push(auxPanel)
            }

            //remove all childs
            document.getElementById("editor-content").innerHTML = '';
            panelsArray.forEach((panel) => {
                document.getElementById("editor-content").appendChild(panel);
            })
          //  this.storeElements()

          }
      },
      handleClickOutside(e) {
        const dropdownRefs = [
            this.$refs['showBgConfigRef'],
            this.$refs['fontGroupEdition'],
            this.$refs['panelMoveOrder'],
            this.$refs['hiddenSidebar'],
        ];
        const dropdownLiIds = [
            document.getElementById("popup-bg-config-ref"),
            document.getElementById("popup-font-group-edition"),
            document.getElementById("popup-panels-to-move"),
            document.getElementById("popup-hidden-side-bar"),
        ];

        let clickedInside = false;

        dropdownLiIds.forEach(ref => {
            if (ref && ref.contains(e.target)) {
                clickedInside = true;
            }
        });

        if (!clickedInside) {
            dropdownRefs.forEach(ref => {
                if (ref) {
                  ref.hidePanel();
                }
            });
          }
      }
    },

    async created() {
      await this.getUserPlan();

      if (this.$route.name === 'editor' && this.$route.params.page_id) {

        var vm = this;

        function getFooterItem(device, footer_id) {
          let footer = {...vm.itemFooters.find(footer => parseInt(footer.id) === parseInt(footer_id))};
          if (footer && footer.content && vm.$isJson(footer.content)) {
            vm.itemFooter[device] = footer;
            vm.itemFooter[device].content = JSON.parse(footer.content);
          }
        }

        function getHeaderItem(device, header_id) {
          let header = {...vm.itemHeaders.find(header => parseInt(header.id) === parseInt(header_id))};
          if (header && header.content && vm.$isJson(header.content)) {
            vm.itemHeader[device] = header;
            vm.itemHeader[device].content = JSON.parse(header.content);
          }
        }

        await getBit(this.$route.params.page_id)
          .then(async response => {
            if (response.data) {
              this.page = response.data;
              this.website = response.data.layout.website;
              this.pages = response.data.layout.pages;
              this.hasRestrictsArea = response.data.hasRestrictsArea;
              this.id_layout = response.data.encrypted_layout_id;
              this.id_website = response.data.layout.encrypted_website_id;

              this.getSuperCheckoutAuth();

              let pageConfig = response.data.config;

              getWebsiteLink(this.id_website).then((response) => {
                if (response.data.layouts[0]) {
                  let layout = response.data.layouts[0];
                  this.itemHeaders = layout.headers;
                  this.itemFooters = layout.footers;
                }
              });

              if (typeof pageConfig !== 'undefined' && pageConfig.headerSettings !== 'undefined' && pageConfig.headerSettings != null) {
                let header = JSON.parse(pageConfig.headerSettings.value);
                if (header) {
                  if (header.desktop.header_id !== 0) {
                    getHeaderItem('desktop', header.desktop.header_id);
                  }

                  if (header.mobile.header_id !== 0) {
                    getHeaderItem('mobile', header.mobile.header_id);
                  }
                }
              }

              if (typeof pageConfig !== 'undefined' && pageConfig.footerSettings !== 'undefined' && pageConfig.footerSettings != null) {
                let footer = JSON.parse(pageConfig.footerSettings.value);
                if (footer) {
                  if (footer.desktop.footer_id !== 0) {
                    getFooterItem('desktop', footer.desktop.footer_id);
                  }

                  if (footer.mobile.footer_id !== 0) {
                    getFooterItem('mobile', footer.mobile.footer_id);
                  }
                }
              }
            }
          });
      }
    },

    mounted() {
      this.$root.$on('changePointerState', (value) => {
        // this.$eventPointer.changePointerState(value);
      })

      // this.$root.$on(['toggleElement'], () => this.store());

      let vm = this;

      document.addEventListener('click', this.handleClickOutside);

      this.page_id = this.$route.params.page_id;

      localStorage.removeItem('ruler_marks');

      localStorage.removeItem('editor-pp-structure');

      window.addEventListener('click', this.submit);

      window.addEventListener('keydown', this.keyboardMap);

      if (typeof webpackHotUpdate === 'undefined') {
        window.addEventListener('beforeunload', this.beforeClose);
      }

      this.$root.$on('fontGroup', (data) => {
        this.fontGroupEdition = data;
      });

      this.$root.$on('showReCaptcha', (siteKey, privateKey, callback) => {
        this.$nextTick(async () => {
          await this.$refs['recaptchaPopup'].init(siteKey, privateKey, callback);
          await this.$refs['recaptchaPopup'].openModal();
        });
      });


      this.$root.$on('configFields', (fields, previous, callback, configs) => {
        this.$nextTick(async () => {
          await this.$refs['configFields'].init(fields, previous, callback, configs);
          await this.$refs['configFields'].openModal();
        });
      });

      this.$root.$on('showButtonMultipleActions', (event, actions, callback) => {
        this.$nextTick(async () => {
          await this.$refs['buttonMultipleActions'].open(event, actions, callback);
        });
      });

      this.$root.$on('openSimpleFormModal', (internal_config, modal, callback) => {
        this.$nextTick(async () => {
          await this.$refs['simple-form-modals'].init(internal_config, callback);
          await this.$refs['simple-form-modals'].open(modal);
        });
      });

      this.$root.$on('openMultiStepFormModal', (internal_config, modal, callback) => {
        this.$nextTick(async () => {
          await this.$refs['multi-step-form-modals'].init(internal_config, callback);
          await this.$refs['multi-step-form-modals'].open(modal);
        });
      });

      this.$root.$on('openMailingBossFormModal', (internal_config, element, callback, modal = 'config') => {
        this.$nextTick(async () => {
          await this.$refs['mailingboss-form-modals'].init(internal_config, element, callback, modal);
          await this.$refs['mailingboss-form-modals'].open();
        });
      });

      this.$root.$on('openFormConfigSocialProofConfigModal', (internal_config, name, key, callback) => {
        this.$nextTick(async () => {
          await this.$refs['form-config-social-proof-modal'].init(internal_config, name, key, callback);
          await this.$refs['form-config-social-proof-modal'].open();
        });
      });

      this.$root.$on('openGetResponseModal', (internal_config, element, callback, modal = 'config') => {
        this.$nextTick(async () => {
          await this.$refs['getresponse-form-modals'].init(internal_config, callback, element);
          await this.$refs['getresponse-form-modals'].open(modal);
        });
      });

      this.$root.$on('openMenuModal', (internal_config, modal, callback) => {
        this.$nextTick(async () => {
          await this.$refs['menu-modals'].init(internal_config, callback);
          await this.$refs['menu-modals'].open(modal);
        });
      });

      this.$root.$on('openGalleryVideoModal', (internal_config, modal, callback) => {
        //console.log('rá');
        this.$nextTick(async () => {
          await this.$refs['gallery-video-modals'].init(internal_config, callback);
          //console.log(modal);
          await this.$refs['gallery-video-modals'].open(modal);
        });
      });


      this.$root.$on('openSliderGalleryModal', (internal_config, modal, callback) => {
        this.$nextTick(async () => {
          await this.$refs['slider-modals'].init(internal_config, callback);
          await this.$refs['slider-modals'].open(modal);
        });

      });

      this.$root.$on('openImageGalleryModal', (internal_config, modal, callback) => {
        this.$nextTick(async () => {
          await this.$refs['gallery-modals'].init(internal_config, callback);
          await this.$refs['gallery-modals'].open(modal);
        });
      });
      this.$root.$on('openCheckoutModal', (internal_config, modal, callback) => {
        this.$nextTick(async () => {
          await this.$refs['checkout-modals'].init(internal_config, callback);
          await this.$refs['checkout-modals'].open(modal);
        });
      });


      this.$root.$on('openModal', (config, element, callback) => {
        this.$nextTick(async () => {
          await this.$refs['modal-manager'].init(config, element, callback);
        });
      });

      this.$root.$on('openBlogSettingsModal', (internalConfig, element, callback) => {
        this.$nextTick(async () => {
          await this.$refs['blog-settings-modal'].init(internalConfig, callback);
          await this.$refs['blog-settings-modal'].open(element);
        });
      });

      this.$root.$on('openBlogNewsSliderModal', (internal_config, modal, callback) => {
        this.$nextTick(async () => {
          await this.$refs['blog-news-slider-modal'].init(internal_config, callback);
          await this.$refs['blog-news-slider-modal'].open(modal);
        });
      })

      this.$root.$on('openButtonUserLinkModal', (config, callback) => {

      this.$nextTick(() => {
        this.$refs['link-button-user'].init(config, callback);
        this.$refs['link-button-user'].openModal();
      });

    });

      this.$root.$on('openContentNavUserSettingModal', (config, callback) => {

        this.$nextTick(() => {
          this.$refs['settings-container-user'].init(config, callback);
          this.$refs['settings-container-user'].openModal();
        });

      });

      this.$root.$on('openBookingCalendarModal', (config, modal, callback) => {

        this.$nextTick(async () => {
          await this.$refs['booking-calendar-modal'].init(config, callback);
          await this.$refs['booking-calendar-modal'].open(modal);
        });

      });

      this.$root.$on('openQuizModal', (config, modal, callback) => {

        this.$nextTick(async () => {
          await this.$refs['quiz-config-modal'].init(config, callback);
          await this.$refs['quiz-config-modal'].open(modal);
        });

      });

      this.$root.$on('openPandaVideoModal', (config, callback) => {
        this.$nextTick(async () => {
          await this.$refs['panda-video-config-modal'].init(config, callback);
          await this.$refs['panda-video-config-modal'].open();
        });
      });

      function extensionFont(path) {
        if (path.indexOf('ttf') !== -1) {
          return 'truetype';
        }
        if (path.indexOf("otf") !== -1) {
					return 'opentype';
				}
        if (path.indexOf('woff2') !== -1) {
          return 'woff2';
        }
        if (path.indexOf('woff') !== -1) {
          return 'woff';
        }
        return 'truetype';
      }

      function loadUserFonts() {
        if (typeof vm.getUser().email !== 'undefined') {
          clearInterval(timerLoadFonts);
          timerLoadFonts = false;

          axios.get('https://sitebuilder-admin.kub.app.builderall.com/user_fonts/user/' + vm.getUser().email).then((res) => {
            let fonts = res.data;

            let style = document.createElement('style');
            fonts.forEach(elem => {
              if (!elem.deleted_at) {
                vm.$refs.manageFontUpload.setFont({id: elem.id, text: elem.name, value: elem.name});
                vm.$root.$emit('addFonts', {text: elem.name, value: elem.name});
                vm.$root.$emit('addFontsCk', {text: elem.name, value: elem.name});

                // style.innerHTML += `@import url('https://sitebuilder-admin.kub.app.builderall.com/storage/` + elem.path + `');`;
                style.innerHTML += `@font-face {  font-family: '` + elem.name + `';  src: url('https://cheetah-templates.builderall.com/storage/` + elem.path + `') format('` + extensionFont(elem.path) + `');}`;
              }
            });
            document.head.appendChild(style);
          });
        }
      }

      // controle de edição de itens default
      if (this.$route.name === 'editor-default-item') {
        getDefaultItem(this.$route.params.id_default_item)
          .then(res => {
            this.defaultItem = res.data;

            this.default_item_type = res.data.category.type;

            // se não houver elemento jogar painel default de edição nos elementos para adição
            if (this.default_item_type === 'app') {
              this.elements.push({
                'name': 'PanelElement',
                'id': 'panel-default-item',
                'config': {
                  'height': '400px',
                  'background': '#dddddd',
                  'backgroundColor': '#dddddd',
                  'order_mobile': 0
                },
                'childs': []
              });

              if (res.data.content != '{}') {
                this.elements[0].childs.push(JSON.parse(res.data.content));
                vm.$eventHub.addElements(vm.elements);

              }

              this.$nextTick(function () {
                vm.sort();
              });
            } else {
              try {
                let data = JSON.parse(res.data.content);
                data.forEach(newPanel => {
                  vm.elements.push(newPanel);
                });

                this.$nextTick(function () {
                  vm.$eventHub.addElements(vm.elements);
                  // vm.$eventPointer.addElements(vm.elements);
                  vm.sort();
                });
              } catch (e) {
                console.warn('catch', e);
                vm.elements = [];
                this.$nextTick(function () {
                  vm.$eventHub.addElements(vm.elements);
                  // vm.$eventPointer.addElements(vm.elements);
                  vm.sort();
                });
              }
            }
          });
      } else {
        if (this.$route.name === 'editor-layout-item') {
          this.layout_item_type = this.$route.params.type;
          this.id_website = this.$route.params.website_id;

          switch (this.layout_item_type) {
            case 'header': {
              this.getLayoutItem = getHeader;
              this.updateLayoutItem = updateHeader;
              break;
            }

            case 'footer': {
              this.getLayoutItem = getFooter;
              this.updateLayoutItem = updateFooter;
              break;
            }

            case 'popup': {
              document.getElementById('editor-content').classList.add('popup-editor');
              this.getLayoutItem = getPopup;
              this.updateLayoutItem = updatePopup;
              break;
            }
          }

          this.$loading.show();
          this.getLayoutItem(this.$route.params.id_item)
            .then(res => {
              this.layoutItem = res.data;
              if (res.data.content !== null) {
                this.elements = JSON.parse(res.data.content);
              }
              this.$eventHub.addElements(this.elements);
              // this.$eventPointer.addElements(this.elements);

              this.$loading.show();

              getLayoutConfig(res.data.layout_encrypted_id).then(res => {
                vm.id_page = this.page_id;
                if (typeof res.data['fontGroup'] !== 'undefined') {
                  vm.fontGroup = JSON.parse(res.data['fontGroup'].value);
                }
                vm.$root.$emit('fontGroup', vm.fontGroup);
                vm.applyFontGroup();

                if (typeof res.data['presetColors'] !== 'undefined') {
                  localStorage.setItem('presetColors', JSON.parse(res.data['presetColors'].value));
                }
              }).finally(() => this.$loading.hide());

              this.$nextTick(function () {
                vm.sort();
              });
            }).finally(() => this.$loading.hide());
        } else {
          // fazer logica para pagina inicial e layout default
          if (this.id_layout === null) {
            this.$loading.show();
            // getLayouts(this.id_website)
            // 	.then((data) => {
            // 		this.id_layout = data.data.id;
            getItems(this.page_id)
              .then(res => {
                  this.id_website = res.data.encrypted_website_id;
                  this.id_layout = res.data.encrypted_layout_id;
                  this.tablet_version = res.data.tablet_version;
                  this.elements = res.data.configurations ? JSON.parse(res.data.configurations) : [];
                  this.$eventHub.addElements(this.elements);
                  // this.$eventPointer.addElements(this.elements);

                  this.checkJoyRide();

                  this.$nextTick(function () {
                    vm.sort();
                    this.$loading.show();
                    getLayoutConfig(this.id_layout).then(res => {
                      vm.id_page = this.page_id;
                      if (typeof res.data['fontGroup'] !== 'undefined') {
                        vm.fontGroup = JSON.parse(res.data['fontGroup'].value);
                      }
                      vm.$root.$emit('fontGroup', vm.fontGroup);
                      vm.applyFontGroup();

                      if (typeof res.data['presetColors'] !== 'undefined') {
                        localStorage.setItem('presetColors', JSON.parse(res.data['presetColors'].value));
                      }

                      getPageConfig(this.id_page).then(resPage => {
                        if (typeof resPage.data.bgPropsPage !== 'undefined') {
                          vm.bgPropsPage = JSON.parse(resPage.data.bgPropsPage.value);
                        }

                        vm.$refs.resourcesPage.element = vm.bgPropsPage;
                        vm.$refs.resourcesPage.resources.backgroundColor.defaultValue = vm.bgPropsPage.backgroundColor;
                        vm.$refs.resourcesPage.resources.src.defaultValue = vm.bgPropsPage.backgroundImage;
                        vm.$refs.resourcesPage.resources.src.defaultValueOrigin = vm.bgPropsPage.backgroundOrigin;
                        vm.$refs.resourcesPage.resources.src.defaultValueRepeat = vm.bgPropsPage.backgroundRepeat;
                        vm.$refs.resourcesPage.resources.src.defaultValueSize = vm.bgPropsPage.backgroundSize;
                        vm.$refs.resourcesPage.resources.src.defaultValuePosition = vm.bgPropsPage.backgroundPosition;
                        if (typeof vm.bgPropsPage.backgroundAttachment !== 'undefined') {
                          vm.$refs.resourcesPage.resources.src.defaultValueAttachment = vm.bgPropsPage.backgroundAttachment
                        }

                        if (typeof resPage.data.anchors !== 'undefined') {
                          vm.anchors = JSON.parse(resPage.data.anchors.value);
                        }

                        vm.applyBackground();

                        if (!window.getCookie('joyride-executed') && !localStorage.getItem('joyride-executed')) {
                          this.stepsOptions.labels.buttonSkip = this.$t('ct-joyride-skip-tour');
                          this.stepsOptions.labels.buttonPrevious = this.$t('ct-joyride-previous');
                          this.stepsOptions.labels.buttonNext = this.$t('ct-joyride-next');
                          this.stepsOptions.labels.buttonStop = this.$t('ct-joyride-finish');

                          this.steps = [
                            {
                              target: '.panel-components-right', // We're using document.querySelector() under the hood
                              content: this.$t('ct-joyride-panel-components-right'),
                              params: {
                                placement: 'right'
                              }
                            },
                            {
                              target: '#tab-add-panel', // We're using document.querySelector() under the hood
                              content: this.$t('ct-joyride-add-panel'),
                              params: {
                                placement: 'right'
                              }
                            },
                            {
                              target: '#tab-add-panel-action', // We're using document.querySelector() under the hood
                              content: this.$t('ct-joyride-add-panel-action'),
                              params: {
                                placement: 'right'
                              }
                            },
                            {
                              target: '#addpanel-tab-list', // We're using document.querySelector() under the hood
                              content: this.$t('ct-joyride-add-panel-action-list'),
                              params: {
                                placement: 'right'
                              }
                            },
                            {
                              target: '#top-menu-left', // We're using document.querySelector() under the hood
                              content: this.$t('ct-joyride-top-menu-left'),
                              params: {
                                placement: 'bottom'
                              }
                            },
                            {
                              target: '#top-menu-right', // We're using document.querySelector() under the hood
                              content: this.$t('ct-joyride-top-menu-right'),
                              params: {
                                placement: 'bottom'
                              }
                            }
                          ];

                          this.$nextTick(() => {
                            vm.$tours['editorTour'].start();
                            this.tour = vm.$tours['editorTour'];
                          });
                        }

                        vm.$loading.hide();
                      });
                    }).finally(() => this.$loading.hide());
                  });
                }
              )
              .catch((error) => {
                console.warn(error);
                this.$loading.hide();
                this.$router.push({
                  name: 'Dashboard'
                });
              });
            // })
            // .catch((error) => console.warn(error));
          }
        }

        // Start timer
        var timerLoadFonts = setInterval(loadUserFonts, 1000);
      }

      this.$nextTick(function () {
        vm.sort();
      });

      //* ********page methods**************

      this.$root.$on('getFirstElement', async (resolve) => {
        let firstPanel = vm.getFirstPanel();

        await setTimeout(() => resolve(firstPanel), 1);
      });


      this.$root.$on('updateAnchor', (element) => {
        const {id, internal_config, config} = element;

        const {
          anchorActive,
          anchorName,
        } = internal_config.anchorActive !== undefined && internal_config.anchorName !== undefined
          ? internal_config
          : config;

        if (anchorActive === true) this.anchors[id] = anchorName;
        else if (this.anchors[id]) delete this.anchors[element.id];

        if (this.anchorsThrottle.timer) clearTimeout(this.anchorsThrottle.timer);
        this.anchorsThrottle.timer = setTimeout(() => setPageConfig({
          page_id: this.page_id,
          key: 'anchors',
          value: JSON.stringify(Object.assign({}, this.anchors))
        }), 1e3);
      });


      this.$root.$on('createBaseElement', (elem, data, parentId, callback) => {
        this.createElement(parentId, elem, data, null, callback);

        this.$nextTick(function () {
          this.checkJoyRide();
        });
      });

      this.$root.$on('changeBgConfigPage', (data) => {
        Object.keys(data).forEach(prop => {
          this.bgPropsPage[prop] = data[prop];
        });

        this.applyBackground();
      });

      //* ********end page methods**********

      //* ********font methods**************

      this.$root.$on('setGroupFontsOnEditor', (editor) => {
        Object.keys(this.fontGroup).forEach(font => {
          if (typeof editor.dom.select(font) !== 'undefined' && editor.dom.select(font).length > 0) {
            editor.dom.setStyle(editor.dom.select(font), 'font-family', this.fontGroup[font].family);
            editor.dom.setStyle(editor.dom.select(font), 'font-size', this.fontGroup[font].size);
            editor.dom.setStyle(editor.dom.select(font), 'color', this.fontGroup[font].color);
            editor.dom.setStyle(editor.dom.select(font), 'line-height', this.fontGroup[font]['line-height']);
            // editor.dom.setStyle(editor.dom.select(font), 'text-align', this.fontGroup[font]['text-align']);
          }
        });
      });

      this.$root.$on('changeFontGroup', (font, index, value) => {
        if (index === 'size' || index === 'sizeMobile') {
          value = value + 'px';
        }
        if (index === 'line-height') {
          value = value + 'em';
        }
        this.fontGroup[font][index] = value;
        this.applyFontGroup();
      });

      //* ********end font methods**********

      //* ********popup methods**************
      this.$root.$on('PinElement', (elem) => {
        if (!this.preview) {
          this.$refs.PinComponent.setValues(elem);
          this.$refs.PinComponent.openModal();


          if (elem.internal_config.pinConfig.btnClick == null) {
             $('.btnColor').css('background-color', '#ffff');
             elem.internal_config.pinConfig.type == '';
          } else {
            $('.btnColor').css('background-color', '#ffff');
            $(`${elem.internal_config.pinConfig.btnClick}`).css('background-color', '#6495ED');
          }
          ;
        }
      });

      this.$root.$on('hidePinElement', (elem) => {
        this.$refs.PinComponent.hideModal();
      });

      // StickyVideo
      this.$root.$on('StickyElement', (elem) => {
        if (!this.preview) {
          this.$refs.StickyComponent.setValues(elem);
          this.$refs.StickyComponent.openModal();

          if (elem.internal_config.sizeSticky == '') {
            $('.btnSizeSticky').css('background-color', '#ffff');
          } else {
            if (elem.internal_config.sizeSticky == 'small') {
              $('.btnSizeSticky').css('background-color', '#ffff');
              $('#btnSizeSmall').css('background-color', '#05c1fc');
            } else if (elem.internal_config.sizeSticky == 'medium') {
              $('.btnSizeSticky').css('background-color', '#ffff');
              $('#btnSizeMedium').css('background-color', '#05c1fc');
            } else {
              $('.btnSizeSticky').css('background-color', '#ffff');
              $('#btnSizeLarge').css('background-color', '#05c1fc');
            }
          }
          if (elem.internal_config.btnClick == null) {
            $('.btClick').css('background-color', '#ffff');
          } else {
            $('.btClick').css('background-color', '#ffff');
            $(`${elem.internal_config.btnClick}`).css('background-color', '#6495ED');
          }
          ;
        }
      });

      this.$root.$on('hideStickyElement', (elem) => {
        this.$refs.StickyComponent.hideModal();
      });

      this.$root.$on('linkComponentShow', (elem, data, callback, callIfCancel) => {
        if (!this.preview) {
          // console.log(data)
          this.$refs.linkComponent.loadData(elem, data, callback, 'all', callIfCancel);
        }
      });

      this.$root.$on('linkComponentForm', (elem, data, callback) => {
        if (!this.preview) {
          this.$refs.linkComponent.loadData(elem, data, callback, 'mboss');
        }
      });

      this.$root.$on('saveElement', (elem) => {
        this.$refs.saveElementComponent.setValues(elem);
        this.$refs.saveElement.open();
      });


      this.$root.$on('editText', (elem) => {
        // this.$refs.saveElementComponent.setValues(elem);
        this.$refs.textEditorOpen.showEditor(elem);

        this.$refs.editText.open();
      });

      this.$root.$on('editMagicTextOpen', (elem) => {
        this.$refs.textEditor2Open.showEditor(elem);

        this.$refs.editMagicTextOpen.open();
      });

      this.$root.$on('hideSaveElement', () => {
        this.$refs.saveElement.close();
      });

      this.$root.$on('fontUpload', (options) => {
        this.$refs.fontUploadComponent.setValues();
        this.$refs.uploadFont.open();
      });

      this.$root.$on('manageFontUpload', () => {
        this.$refs.manageFontUpload.open();
      });

      this.$root.$on('manageFontUploadDelete', (font_id) => {
        this.$refs.deleteManageFontUpload.open();
      });

      this.$root.$on('hideFontUpload', () => {
        this.$refs.uploadFont.close();
      });

      //* ********end popup methods**********

      //* ********elements methods**************


      this.$root.$on('selectElement', elem => {
        this.selectedElement = elem;
      });

      this.$root.$on('activeSort', () => {
        this.sort();
      });

      this.$root.$on('duplicateElement', (elem, config) => {
        let editorDiv = document.getElementById('editor-content');
        let panelsDiv = editorDiv.querySelectorAll('.panel');

        this.saveData = [];
        this.runUpdatesOnElements(this.saveData, panelsDiv);

        let id = elem.$el.id == '' ? elem.id : elem.$el.id;
        let parentId = elem.$el.parentNode.parentNode.id || elem.$el.parentNode.parentNode.parentNode.id;

        parentId = parentId.replace('collapse', '');

        let parentTop = document.getElementById(parentId).getBoundingClientRect().top + window.scrollY - 40;
        let parentLeft = document.getElementById(parentId).getBoundingClientRect().left;
        let leftPanel = document.getElementById(parentId).classList.contains('panel') ? document.querySelector('.panel-body').getBoundingClientRect().left : 0;

        // deepclone
        let clonedElement = JSON.parse(JSON.stringify(this.$eventHub.getElement(id)));

        let obj = clonedElement.config;
        let newId = this.getNextId();
        obj.parent_id = parentId;
        obj.id = newId;
        obj['top'] = (elem.$el.getBoundingClientRect().top + window.scrollY - 40 - parentTop + 20) + 'px';
        obj['left'] = (elem.$el.getBoundingClientRect().left - parentLeft - leftPanel + 40) + 'px';

        let objData = {
          id: newId,
          name: elem.$el.getAttribute('element'),
          config: obj
        };

        if (typeof clonedElement.childs !== 'undefined' && clonedElement.childs.length > 0) {
          objData['childs'] = clonedElement.childs;
        }

        var scrollTop = document.getElementById('panel-constructor').scrollTop;
        this.elements = this.$eventHub.duplicateElement(parentId, objData);
        this.keyElements = this.genRandomKey();

        this.$nextTick(() => {
          this.$root.$emit('setChildsObj', parentId);
          // Forcer manter o scroll onde estava a copia
          document.getElementById('panel-constructor').scrollTop = scrollTop;
        });
      });

      this.$root.$on('toggleElement', (elemS) => {
        let id = elemS.$el.id == '' ? elemS.id : elemS.$el.id;
        this.elements = this.$eventHub.toggleElement(id, this.device, false);


        this.$root.$emit('setConfigElement', id, this.$eventHub.getConfig(id));

        this.$nextTick(() => {
          this.sort();
        });
      });

      this.$root.$on('toggleElementById', (id) => {
        this.elements = this.$eventHub.toggleElement(id, this.device, true);

        this.$root.$emit('setConfigElement', id, this.$eventHub.getConfig(id));

        this.$nextTick(() => {
          this.sort();
        });
      });


      this.$root.$on('changeOrderElementsInside', (parentId, id, siblingID, idx) => {
        parentId = parentId.replace('collapse', '');

        this.changeOrderElements(parentId, id, siblingID, idx);

        let elements = this.$eventHub.getElement(parentId);

        elements.childs.forEach((child, idxChild) => {
          if (child.id == id) {
            elements.childs[idxChild].config.order_mobile = child.config.order_mobile + (idx);
          }
          if (child.id == siblingID) {
            elements.childs[idxChild].config.order_mobile = child.config.order_mobile - (idx);
          }
        });

        this.$eventHub.setValueElement(parentId, elements);

        this.$nextTick(() => {
          this.$root.$emit('setChildsObj', parentId);
          this.$nextTick(() => {
            this.sort();
          });
        });
      });


      this.$root.$on('focusElement', (elem) => {
        this.hidePopup();

        this.selectedElement = elem;
        let elements = document.getElementsByClassName('widget-focused');
        [].forEach.call(elements, function (el) {
          el.classList.remove('widget-focused');
          el.classList.remove('default-options-top');
          el.classList.remove('default-options-left');

        });
        if (!this.preview) {
          elem.$el.classList.add('widget-focused');


          if (elem.$el.getBoundingClientRect().top < 120) {
            $(elem.$el).addClass('default-options-top');
          } else {
            $(elem.$el).removeClass('default-options-top');
          }

          if (elem.$el.getBoundingClientRect().left > (window.innerWidth - 300)) {
            $(elem.$el).addClass('default-options-right');
          } else {
            $(elem.$el).removeClass('default-options-right');
          }

          if (elem.$el.getBoundingClientRect().left < (window.innerWidth - 300)) {
            $(elem.$el).addClass('default-options-left');

          } else {
            $(elem.$el).removeClass('default-options-left');
          }

          if (elem.$el.getBoundingClientRect().top < 100) {
            $(elem.$el).find('.default-resource_components').addClass('top-option');
          } else {
            $(elem.$el).find('.default-resource_components').removeClass('top-option');
          }
        }
      });

      this.$root.$on('showResourceRightSideBar', (resource, status) => {
        vm.$refs['rightSidebarEdition'].resourcesActive[resource] = status;
      });

      this.$root.$on('handlerElement', (elem, force) => {
        // console.log(elem);
        if (!this.preview) {

          if (force || $('.off-sidebar').length === 0 ) {

            // if(typeof vm.$refs['rightSidebarEdition'] !== 'undefined' && vm.$refs['rightSidebarEdition'].rigthSidebarEdition() !== 'undefined') {

                vm.$refs['rightSidebarEdition'].rigthSidebarEdition(elem);

                var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                if (isSafari) { // safari abrir sempre em sidebar

                  $('.off-sidebar').removeClass('off-sidebar').addClass('default-sidebar').addClass('default-safari');

                  $('.modal-header-sidebar').hide();
                  return;
                }

                let modal = $('.modal-settings-dialog');

                let leftElement = elem.$el.offsetWidth

                if (leftElement === 0) {
                  leftElement = $('#' + elem.$el.id + ' > .vdr').width();
                }


                let elementName = 'ct-component-' + elem.$el.attributes.element.value;

                if (typeof elem.$el.attributes['data-is-drip'] !== 'undefined' && elem.$el.attributes['data-is-drip'].value) {
                  elementName += 'Drip'
                }

                this.titleModal = this.$t(elementName);


                leftElement = elem.$el.getBoundingClientRect().x + leftElement

                if (leftElement > 900) {
                  leftElement = 900;
                }

                let topElement = elem.$el.getBoundingClientRect().y;

                if(topElement < 70){
                  topElement = 72;
                }

                if (!($('.modal.in').length)) {
                  modal.css({
                    top: topElement,
                    left: leftElement,
                  });
                }
                $('#settingsElements').modal({
                  backdrop: false,
                  show: true
                });

                modal.draggable({
                  handle: ".modal-header"
                });

                $('.modal-header-sidebar').show();
                $('.panel-components-right').show();
            // }

          }
        }
      });

      this.$root.$on('deleteElement', (app) => {
        this.elementToDelete = app;
        this.$refs.delete.open();
      });

      this.$root.$on('alignElement', (elem, axis) => {
        if (axis === 'vertical') {
          $('.selected').css('left', elem.$el.offsetLeft + 'px');
        } else {
          $('.selected').css('top', elem.$el.offsetTop + 'px');
        }
      });

      this.$root.$on('refreshPanels', () => {
        let vm = this;
        this.elements = this.updateChilds();
        this.$nextTick(() => {
          vm.keyElements = this.genRandomKey();
          vm.checkJoyRide();
          document.getElementById('panel-constructor').scrollTop = vm.offsetScroll;
        });
      });

      this.$root.$on('setElementsUndoRedo', (elements) => {
        let vm = this;
        this.elements = elements;
        this.$nextTick(() => {
          vm.keyElements = this.genRandomKey();
          vm.checkJoyRide();
          document.getElementById('panel-constructor').scrollTop = vm.offsetScroll;
        });
      });

      //* ********end elements methods**********

      this.$root.$on('initTextEditor', (elem) => {
        this.$refs.textEditor.showEditor(elem);
      });

      // Comentado pro deploy, falta ajeitar o rotate
      this.$root.$on('applySticky', (element) => {
        if (this.device == 'desktop') {
          var $window = $('.panel-constructor');
          var $videoWrap = $(element.$el).find('.sticky-video-content');
          var $video = $(element.$el).find('.sticky-video-content .video');
          var videoHeight = document.getElementById('the-sticky-div').clientHeight;
          $window.on('scroll', function () {
            var windowScrollTop = document.querySelector('.panel-constructor').scrollTop;
            var videoBottom = videoHeight + $videoWrap.offset().top;
            var $elementVideo = $(element.$el).children();
            if (windowScrollTop > videoBottom) {
              // console.log($elementVideo,'eae')
              $elementVideo.css({transform: 'none'});

              // $(removeT).remove();
              // console.log($removeT,'perigoso')
              if (element.internal_config.sizeSticky == 'small') {
                switch (element.internal_config.positionSticky) {
                  case 'top-left':
                    $videoWrap.height(videoHeight);
                    $video.addClass('stuckTL');
                    break;
                  case 'top-right':
                    $videoWrap.height(videoHeight);
                    $video.addClass('stuckTR');
                    break;
                  case 'bottom-left':
                    $videoWrap.height(videoHeight);
                    $video.addClass('stuckBL');
                    break;
                  case 'bottom-right':
                    $videoWrap.height(videoHeight);
                    $video.addClass('stuckBR');
                    break;
                }
              } else if (element.internal_config.sizeSticky == 'medium') {
                switch (element.internal_config.positionSticky) {
                  case 'top-left':
                    $videoWrap.height(videoHeight);
                    $video.addClass('stuckTLm');
                    break;
                  case 'top-right':
                    $videoWrap.height(videoHeight);
                    $video.addClass('stuckTRm');
                    break;
                  case 'bottom-left':
                    $videoWrap.height(videoHeight);
                    $video.addClass('stuckBLm');
                    break;
                  case 'bottom-right':
                    $videoWrap.height(videoHeight);
                    $video.addClass('stuckBRm');
                    break;
                }
              } else {
                switch (element.internal_config.positionSticky) {
                  case 'top-left':
                    $videoWrap.height(videoHeight);
                    $video.addClass('stuckTLl');
                    break;
                  case 'top-right':
                    $videoWrap.height(videoHeight);
                    $video.addClass('stuckTRl');
                    break;
                  case 'bottom-left':
                    $videoWrap.height(videoHeight);
                    $video.addClass('stuckBLl');
                    break;
                  case 'bottom-right':
                    $videoWrap.height(videoHeight);
                    $video.addClass('stuckBRl');
                    break;
                }
              }
            } else {
              // $elementVideo.css({ transform : `${element.internal_config.rotation}`});

              $videoWrap.height('auto');
              $video.removeClass('stuckTR');
              $video.removeClass('stuckTL');
              $video.removeClass('stuckBR');
              $video.removeClass('stuckBL');
              $video.removeClass('stuckTRm');
              $video.removeClass('stuckTLm');
              $video.removeClass('stuckBRm');
              $video.removeClass('stuckBLm');
              $video.removeClass('stuckTRl');
              $video.removeClass('stuckTLl');
              $video.removeClass('stuckBRl');
              $video.removeClass('stuckBLl');
            }
          });
        }
      });

      //PinElement
      this.$root.$on('applyPin', (element) => {
        let elem = element.$el;
          $(elem).css({
          position: element.internal_config.pinConfig.position,
          top: element.internal_config.pinConfig.pTop,
          left: element.internal_config.pinConfig.pLeft,
          right: element.internal_config.pinConfig.pRight

        });


      });

      this.$root.$on('applyAnimation', (vm, defaultClass) => {
        // clean and restore default classes
        vm.$el.className = '';
        $(vm.$el).off('.animation');
        vm.$el.classList.add(defaultClass);

        // prep;
        let animation = vm.internal_config.animation.in;
        if (animation.effect.indexOf('In') !== -1 && ['time', 'scroll'].includes(animation.action)) {
          vm.$el.classList.add('invisible');
        }

        // apply
        let infinite = animation.infinite === true ? vm.$el.classList.add('infinite') : '';
        vm.$el.classList.add(animation.speed);

        //setando tempo de execusão da animação para as animações de saida
        let timeAnimation = 0;

          switch(animation.speed){
            case 'slow':
              timeAnimation = 1950
            break;
            case 'slower':
              timeAnimation = 2950
            break;
            case 'fast':
              timeAnimation = 750
            break;
            case 'faster':
              timeAnimation = 450
            break;
          }

        // apply time
        switch (animation.action) {
          case 'time':
            setTimeout(function () {
              vm.$el.classList.remove('invisible');
              vm.$el.classList.add(animation.effect, 'animated');
            }, animation.time * 1000);
            break;
          case 'click':
            if(animation.effect.indexOf("Out") != -1){
              $(vm.$el).on('click.animation', () => {
              vm.$el.classList.remove('invisible');
              vm.$el.classList.add(animation.effect, 'animated');

              setTimeout(function(){
                   vm.$el.classList.add('displayClass');
                   $('.displayClass').css('display','none');
                },timeAnimation);

              if (!infinite) {
                vm.$el.addEventListener('animationend', function () {
                  vm.$root.$emit('applyAnimation', vm, defaultClass);
                });
              }
            });

            }else{
            $(vm.$el).on('click.animation', () => {
              vm.$el.classList.remove('invisible');
              vm.$el.classList.add(animation.effect, 'animated');
              if (!infinite) {
                vm.$el.addEventListener('animationend', function () {
                  vm.$root.$emit('applyAnimation', vm, defaultClass);
                });
              }
            });
            }
            break;
          case 'hover':

              if(animation.effect.indexOf("Out") != -1){

              $(vm.$el).on('mouseover.animation', () => {
               vm.$el.classList.remove('invisible');
               vm.$el.classList.add(animation.effect, 'animated');

                setTimeout(function(){
                   vm.$el.classList.add('displayClass');
                   $('.displayClass').css('display','none');
                },timeAnimation);

                if (!infinite) {
                  vm.$el.addEventListener('animationend', function () {
                    vm.$root.$emit('applyAnimation', vm, defaultClass);
                  });
                }
              });
              }else{
                $(vm.$el).on('mouseover.animation', () => {
                vm.$el.classList.remove('invisible');
                vm.$el.classList.add(animation.effect, 'animated');
                if (!infinite) {
                  vm.$el.addEventListener('animationend', function () {
                    vm.$root.$emit('applyAnimation', vm, defaultClass);
                  });
                }
              });
              }

            break;
          case 'scroll':

          function getAllTopsParents(element, more = 0) {
            // tratamento para pegar todos o top quando o elemento for filho de outro elemento e do painel
            function findAncestor(el, sel) {
              while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el, sel))) ;
              return el;
            }

            var parent = findAncestor(element, '.sitebuilder-element-container');

            if (parent === null) {
              var panel = findAncestor(element, '[element="PanelComponent"]').getBoundingClientRect().top;
              var elemRect = element.offsetTop;

              return panel + elemRect + more;
            } else {
              return getAllTopsParents(parent, element.offsetTop);
            }
          }

            let element = document.getElementById(vm.$el.id),
              bodyRect = document.body.getBoundingClientRect(),
              elemRect = element.getBoundingClientRect(),
              offset = getAllTopsParents(element) - bodyRect.top;

            if (window.innerHeight >= offset) {
              vm.$el.classList.remove('invisible');
              vm.$el.classList.add(animation.effect, 'animated');
            }

            document.addEventListener('scroll', function () {
              if (document.querySelector('.panel-constructor').scrollTop + window.innerHeight >= offset) {
                vm.$el.classList.remove('invisible');
                vm.$el.classList.add(animation.effect, 'animated');
              }
            }, true /* Capture event */);
            break;
        }
      });
      // setTimeout(() => {
      //   vm.$eventPointer.changePointerState(true);
      // }, 5000)
    }
  };
</script>


<style>

  .popups-set-link{
    z-index: 9002;
  }

  .overlay-tour {
    position: fixed;
    top: 60px;
    left: 0;
    width: calc(100vw - 300px);
    height: 100vh;
    z-index: 9001;
    -webkit-font-smoothing: antialiased;
    //background: rgba(255,255,255,0.9);
    opacity: 1;
    transition: opacity 0.3s;
    transform: translate3D(0, 0, 0);
    background: rgba(37,37,37,0.9) !important;
  }


</style>

<style lang="scss">
[element="GetResponseFormComponent"],
[element="SimpleFormComponent"],
[element="MailingBossFormComponent"] {
  select.form-control[multiple],
  select.form-control[size],
  textarea.form-control:not(.form-control-textarea-has-height) {
    height: auto !important;
  }

  .recaptcha-container {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
  }

  .horizontal-form {
    display: flex;

    .inputs-area {
      width: 50%;
    }

    .place-btn {
      width: 50%;
      position: relative;

      .bt-sb {
        position: absolute;
        bottom: 15px;
        left: 0;
      }
    }
  }
}

[element="VimeoVideoComponent"],
[element="PandaVideoComponent"] {
  .vdr {
    height: auto !important;
  }

  .preview-img {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: auto;
    }

    svg {
      position: absolute;
      font-size: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/editor/base/Editor.vue